"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/dropdown/index.ts
var dropdown_exports = {};
__export(dropdown_exports, {
  ActionDropdown: () => ActionDropdown_default,
  CheckboxDropdown: () => CheckboxDropdown_default,
  IconDropdown: () => IconDropdown_default,
  SimpleDropdown: () => SimpleDropdown_default,
  dropdownColors: () => dropdownColors
});
module.exports = __toCommonJS(dropdown_exports);

// src/dropdown/actionDropdown/ActionDropdown.tsx
var import_classnames4 = __toESM(require("classnames"));
var import_react5 = require("react");

// src/common/contexts/DropdownContext.tsx
var import_react = require("react");
var import_jsx_runtime = require("react/jsx-runtime");
var DropdownContext = (0, import_react.createContext)({
  activeDropdownName: "",
  /**
   * This is a dummy function to satisfy the type checker
   * */
  setActiveDropdownName: (name) => {
  }
});
var useDropdownContext = () => (0, import_react.useContext)(DropdownContext);
var DropdownProviderWrapper = ({
  children
}) => {
  const [activeDropdownName, setActiveDropdownName] = (0, import_react.useState)("");
  return /* @__PURE__ */ (0, import_jsx_runtime.jsx)(
    DropdownContext.Provider,
    {
      value: { activeDropdownName, setActiveDropdownName },
      children
    }
  );
};

// src/fontAwesomeV6Icon/FontAwesomeV6Icon.tsx
var import_classnames = __toESM(require("classnames"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var FontAwesomeV6Icon = ({
  iconStyle,
  iconFamily,
  iconName,
  className,
  title,
  animationType,
  ...HTMLAttributes3
}) => /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
  "i",
  {
    "data-testid": "font-awesome-v6-icon",
    className: (0, import_classnames.default)(
      iconFamily && `fa-${iconFamily}`,
      iconStyle && `fa-${iconStyle}`,
      iconName && `fa-${iconName}`,
      // Default icon style is solid, but only when no iconFamily prop is provided
      !iconFamily && !iconStyle && "fa-solid",
      animationType && `fa-${animationType}`,
      className
    ),
    title,
    ...HTMLAttributes3
  }
);
var FontAwesomeV6Icon_default = FontAwesomeV6Icon;

// src/dropdown/_CustomDropdown.tsx
var import_classnames3 = __toESM(require("classnames"));
var import_react4 = require("react");

// src/button/Button.tsx
var import_react3 = require("react");

// src/button/_BaseButton.tsx
var import_classnames2 = __toESM(require("classnames"));
var import_react2 = require("react");

// src/button/_baseButton.module.scss
var css = `/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/* This file consists of Semantic colors,
 if you need DSCO colors with support of multiple themes, you need to import and use this file.
 */
/* Colors are taken from DSCO Variables New Figma File - Semantic colors colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Semantic Colors */
/* Semantic colors values are taken from Primitive Colors (primitiveColors.css).
 Semantic color value is specified for every theme, meaning that unlike Primitive Colors (primitiveColors.css), Semantic colors are meant to be different for every theme.
 */
/* Light theme Semantic colors 
(Light theme is a default one, that's why here's also :root rule)
*/
:root,
[data-theme=Light] {
  --background-brand-aqua-light: var(--brand-aqua-10);
  --background-brand-aqua-primary: var(--brand-aqua-50);
  --background-brand-aqua-strong: var(--brand-aqua-70);
  --background-brand-purple-extra-light: var(--brand-purple-5);
  --background-brand-purple-hover: var(--brand-purple-10);
  --background-brand-purple-light: var(--brand-purple-10);
  --background-brand-purple-primary: var(--brand-purple-50);
  --background-brand-purple-strong: var(--brand-purple-70);
  --background-brand-teal-extra-light: var(--brand-teal-5);
  --background-brand-teal-light: var(--brand-teal-10);
  --background-brand-teal-primary: var(--brand-teal-50);
  --background-brand-teal-strong: var(--brand-teal-70);
  --background-error-light: var(--sentiment-error-10);
  --background-error-primary: var(--sentiment-error-50);
  --background-error-strong: var(--sentiment-error-70);
  --background-info-light: var(--sentiment-information-10);
  --background-info-primary: var(--sentiment-information-50);
  --background-info-strong: var(--sentiment-information-70);
  --background-neutral-black-fixed: var(--neutral-base-black);
  --background-neutral-disabled: var(--neutral-gray-20);
  --background-neutral-octonary: var(--neutral-gray-80);
  --background-neutral-primary: var(--neutral-base-white);
  --background-neutral-primary-inverse: var(--neutral-base-black);
  --background-neutral-quaternary: var(--neutral-gray-20);
  --background-neutral-quinary: var(--neutral-gray-30);
  --background-neutral-secondary: var(--neutral-gray-5);
  --background-neutral-senary: var(--neutral-gray-50);
  --background-neutral-septenary: var(--neutral-gray-70);
  --background-neutral-tertiary: var(--neutral-gray-10);
  --background-neutral-white-fixed: var(--neutral-base-white);
  --background-success-light: var(--sentiment-success-10);
  --background-success-primary: var(--sentiment-success-50);
  --background-success-strong: var(--sentiment-success-70);
  --background-warning-light: var(--sentiment-warning-10);
  --background-warning-primary: var(--sentiment-warning-50);
  --background-warning-strong: var(--sentiment-warning-70);
  --borders-brand-aqua-light: var(--brand-aqua-10);
  --borders-brand-aqua-primary: var(--brand-aqua-50);
  --borders-brand-aqua-strong: var(--brand-aqua-70);
  --borders-brand-purple-light: var(--brand-purple-10);
  --borders-brand-purple-primary: var(--brand-purple-50);
  --borders-brand-purple-strong: var(--brand-purple-70);
  --borders-brand-teal-light: var(--brand-teal-10);
  --borders-brand-teal-primary: var(--brand-teal-50);
  --borders-brand-teal-strong: var(--brand-teal-70);
  --borders-error-light: var(--sentiment-error-10);
  --borders-error-primary: var(--sentiment-error-50);
  --borders-error-strong: var(--sentiment-error-70);
  --borders-info-light: var(--sentiment-information-10);
  --borders-info-primary: var(--sentiment-information-50);
  --borders-info-strong: var(--sentiment-information-70);
  --borders-neutral-disabled: var(--neutral-gray-20);
  --borders-neutral-light: var(--neutral-gray-10);
  --borders-neutral-primary: var(--neutral-gray-20);
  --borders-neutral-solid: var(--neutral-base-black);
  --borders-neutral-strong: var(--neutral-gray-40);
  --borders-success-light: var(--sentiment-success-10);
  --borders-success-primary: var(--sentiment-success-50);
  --borders-success-strong: var(--sentiment-success-70);
  --borders-warning-light: var(--sentiment-warning-10);
  --borders-warning-primary: var(--sentiment-warning-50);
  --borders-warning-strong: var(--sentiment-warning-70);
  --text-brand-aqua-primary: var(--brand-aqua-50);
  --text-brand-aqua-primary-fixed: var(--brand-aqua-50);
  --text-brand-aqua-secondary: var(--brand-aqua-70);
  --text-brand-purple-primary: var(--brand-purple-50);
  --text-brand-purple-primary-fixed: var(--brand-purple-50);
  --text-brand-purple-secondary: var(--brand-purple-70);
  --text-brand-teal-primary: var(--brand-teal-50);
  --text-brand-teal-primary-fixed: var(--brand-teal-50);
  --text-brand-teal-secondary: var(--brand-teal-70);
  --text-error-primary: var(--sentiment-error-50);
  --text-error-primary-fixed: var(--sentiment-error-50);
  --text-error-secondary: var(--sentiment-error-60);
  --text-info-primary: var(--sentiment-information-50);
  --text-info-primary-fixed: var(--sentiment-information-50);
  --text-info-secondary: var(--sentiment-information-70);
  --text-neutral-black-fixed: var(--neutral-base-black);
  --text-neutral-disabled: var(--neutral-gray-20);
  --text-neutral-disabled-inverse: var(--neutral-base-white);
  --text-neutral-inverse: var(--neutral-base-white);
  --text-neutral-placeholder: var(--neutral-gray-40);
  --text-neutral-primary: var(--neutral-base-black);
  --text-neutral-quaternary: var(--neutral-gray-70);
  --text-neutral-secondary: var(--neutral-gray-90);
  --text-neutral-tertiary: var(--neutral-gray-80);
  --text-neutral-white-fixed: var(--neutral-base-white);
  --text-success-primary: var(--sentiment-success-50);
  --text-success-primary-fixed: var(--sentiment-success-50);
  --text-success-secondary: var(--sentiment-success-70);
  --text-warning-primary: var(--sentiment-warning-50);
  --text-warning-primary-fixed: var(--sentiment-warning-50);
  --text-warning-secondary: var(--sentiment-warning-70);
}

/* Dark Theme Semantic Colors */
[data-theme=Dark] {
  --background-brand-aqua-light: var(--brand-aqua-90);
  --background-brand-aqua-primary: var(--brand-aqua-50);
  --background-brand-aqua-strong: var(--brand-aqua-70);
  --background-brand-purple-extra-light: var(--brand-purple-90);
  --background-brand-purple-hover: var(--background-neutral-tertiary);
  --background-brand-purple-light: var(--brand-purple-90);
  --background-brand-purple-primary: var(--brand-purple-50);
  --background-brand-purple-strong: var(--brand-purple-70);
  --background-brand-teal-extra-light: var(--brand-teal-90);
  --background-brand-teal-light: var(--brand-teal-90);
  --background-brand-teal-primary: var(--brand-teal-50);
  --background-brand-teal-strong: var(--brand-teal-70);
  --background-error-light: var(--sentiment-error-90);
  --background-error-primary: var(--sentiment-error-50);
  --background-error-strong: var(--sentiment-error-70);
  --background-info-light: var(--sentiment-information-90);
  --background-info-primary: var(--sentiment-information-50);
  --background-info-strong: var(--sentiment-information-70);
  --background-neutral-black-fixed: var(--neutral-base-black);
  --background-neutral-disabled: var(--neutral-gray-80);
  --background-neutral-octonary: var(--neutral-gray-20);
  --background-neutral-primary: var(--neutral-base-black);
  --background-neutral-primary-inverse: var(--neutral-base-white);
  --background-neutral-quaternary: var(--neutral-gray-80);
  --background-neutral-quinary: var(--neutral-gray-70);
  --background-neutral-secondary: var(--neutral-gray-95);
  --background-neutral-senary: var(--neutral-gray-50);
  --background-neutral-septenary: var(--neutral-gray-30);
  --background-neutral-tertiary: var(--neutral-gray-90);
  --background-neutral-white-fixed: var(--neutral-base-white);
  --background-success-light: var(--sentiment-success-90);
  --background-success-primary: var(--sentiment-success-50);
  --background-success-strong: var(--sentiment-success-70);
  --background-warning-light: var(--sentiment-warning-90);
  --background-warning-primary: var(--sentiment-warning-50);
  --background-warning-strong: var(--sentiment-warning-70);
  --borders-brand-aqua-light: var(--borders-neutral-primary);
  --borders-brand-aqua-primary: var(--borders-neutral-solid);
  --borders-brand-aqua-strong: var(--borders-neutral-strong);
  --borders-brand-purple-light: var(--borders-neutral-primary);
  --borders-brand-purple-primary: var(--borders-neutral-solid);
  --borders-brand-purple-strong: var(--borders-neutral-strong);
  --borders-brand-teal-light: var(--brand-teal-90);
  --borders-brand-teal-primary: var(--brand-teal-50);
  --borders-brand-teal-strong: var(--brand-teal-70);
  --borders-error-light: var(--borders-neutral-primary);
  --borders-error-primary: var(--borders-neutral-solid);
  --borders-error-strong: var(--borders-neutral-strong);
  --borders-info-light: var(--borders-neutral-primary);
  --borders-info-primary: var(--borders-neutral-solid);
  --borders-info-strong: var(--borders-neutral-strong);
  --borders-neutral-disabled: var(--neutral-gray-80);
  --borders-neutral-light: var(--neutral-gray-90);
  --borders-neutral-primary: var(--neutral-gray-80);
  --borders-neutral-solid: var(--neutral-base-white);
  --borders-neutral-strong: var(--neutral-gray-50);
  --borders-success-light: var(--borders-neutral-primary);
  --borders-success-primary: var(--borders-neutral-solid);
  --borders-success-strong: var(--borders-neutral-strong);
  --borders-warning-light: var(--borders-neutral-primary);
  --borders-warning-primary: var(--borders-neutral-solid);
  --borders-warning-strong: var(--borders-neutral-strong);
  --text-brand-aqua-primary: var(--text-neutral-primary);
  --text-brand-aqua-primary-fixed: var(--brand-aqua-50);
  --text-brand-aqua-secondary: var(--text-neutral-tertiary);
  --text-brand-purple-primary: var(--text-neutral-primary);
  --text-brand-purple-primary-fixed: var(--brand-purple-50);
  --text-brand-purple-secondary: var(--text-neutral-tertiary);
  --text-brand-teal-primary: var(--text-neutral-primary);
  --text-brand-teal-primary-fixed: var(--brand-teal-50);
  --text-brand-teal-secondary: var(--text-neutral-tertiary);
  --text-error-primary: var(--text-neutral-primary);
  --text-error-primary-fixed: var(--sentiment-error-50);
  --text-error-secondary: var(--text-neutral-tertiary);
  --text-info-primary: var(--text-neutral-primary);
  --text-info-primary-fixed: var(--sentiment-information-50);
  --text-info-secondary: var(--text-neutral-tertiary);
  --text-neutral-black-fixed: var(--neutral-base-black);
  --text-neutral-disabled: var(--neutral-gray-80);
  --text-neutral-disabled-inverse: var(--neutral-base-black);
  --text-neutral-inverse: var(--neutral-base-black);
  --text-neutral-placeholder: var(--neutral-gray-60);
  --text-neutral-primary: var(--neutral-base-white);
  --text-neutral-quaternary: var(--neutral-gray-30);
  --text-neutral-secondary: var(--neutral-gray-10);
  --text-neutral-tertiary: var(--neutral-gray-20);
  --text-neutral-white-fixed: var(--neutral-base-white);
  --text-success-primary: var(--text-neutral-white-fixed);
  --text-success-primary-fixed: var(--sentiment-success-50);
  --text-success-secondary: var(--text-neutral-tertiary);
  --text-warning-primary: var(--text-neutral-primary);
  --text-warning-primary-fixed: var(--sentiment-warning-50);
  --text-warning-secondary: var(--text-neutral-tertiary);
}

/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
._baseButton-module__button___gGYwf,
a._baseButton-module__button___gGYwf {
  display: inline-flex;
  justify-content: center;
  text-align: center;
  align-items: center;
  border-radius: 0.25rem;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  border: 1px solid transparent;
  background-color: transparent;
  color: unset;
  text-decoration: none !important;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}
._baseButton-module__button___gGYwf:focus-visible, ._baseButton-module__button___gGYwf:focus,
a._baseButton-module__button___gGYwf:focus-visible,
a._baseButton-module__button___gGYwf:focus {
  text-decoration: none;
}
._baseButton-module__button___gGYwf._baseButton-module__buttonPendingWithHiddenText___1W2Ul span,
a._baseButton-module__button___gGYwf._baseButton-module__buttonPendingWithHiddenText___1W2Ul span {
  visibility: hidden;
}
._baseButton-module__button___gGYwf._baseButton-module__buttonPendingWithHiddenText___1W2Ul i,
a._baseButton-module__button___gGYwf._baseButton-module__buttonPendingWithHiddenText___1W2Ul i {
  position: absolute;
}
._baseButton-module__button___gGYwf:hover,
a._baseButton-module__button___gGYwf:hover {
  box-shadow: none;
  text-decoration: none;
}
._baseButton-module__button___gGYwf:focus-visible,
a._baseButton-module__button___gGYwf:focus-visible {
  outline: 2px solid var(--brand-teal-50);
  outline-offset: 2px;
  border-radius: 0.375rem;
}
._baseButton-module__button___gGYwf:active,
a._baseButton-module__button___gGYwf:active {
  border: 1px solid transparent !important;
}
._baseButton-module__button___gGYwf:disabled, ._baseButton-module__button___gGYwf[aria-disabled=true],
a._baseButton-module__button___gGYwf:disabled,
a._baseButton-module__button___gGYwf[aria-disabled=true] {
  cursor: not-allowed;
  border-color: var(--neutral-gray-20);
}

._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil {
  background-color: var(--brand-purple-50);
  color: var(--neutral-base-white);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil:hover,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil:hover {
  background-color: var(--brand-purple-70);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil:disabled, ._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil[aria-disabled=true],
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil:disabled,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-purple___31oil[aria-disabled=true] {
  background-color: var(--neutral-gray-20);
  color: var(--neutral-base-white);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL {
  background-color: var(--neutral-base-black);
  color: var(--neutral-base-white);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL:hover,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL:hover {
  background-color: var(--neutral-gray-80);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL:disabled, ._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL[aria-disabled=true],
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL:disabled,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-black___rgoFL[aria-disabled=true] {
  background-color: var(--neutral-gray-20);
  color: var(--neutral-base-white);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR {
  background-color: var(--neutral-base-white);
  color: var(--neutral-base-black);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR:hover,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR:hover {
  background-color: var(--neutral-gray-20);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR:disabled, ._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR[aria-disabled=true],
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR:disabled,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-white___1kMMR[aria-disabled=true] {
  background-color: var(--neutral-gray-80);
  color: var(--neutral-gray-90);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN {
  background-color: var(--sentiment-error-50);
  color: var(--neutral-base-white);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN:hover,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN:hover {
  background-color: var(--sentiment-error-70);
}
._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN:disabled, ._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN[aria-disabled=true],
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN:disabled,
a._baseButton-module__button-primary___2ksGH._baseButton-module__button-destructive___2OpdN[aria-disabled=true] {
  background-color: var(--neutral-gray-20);
  color: var(--neutral-base-white);
}

._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil {
  border: 1px solid var(--brand-purple-50);
  color: var(--brand-purple-50);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil:hover,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil:hover {
  background-color: var(--brand-purple-10);
  border: 1px solid var(--brand-purple-50);
  color: var(--brand-purple-50);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil:active,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil:active {
  border: 1px solid var(--brand-purple-50) !important;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil:disabled, ._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil[aria-disabled=true],
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil:disabled,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-purple___31oil[aria-disabled=true] {
  border-color: var(--neutral-gray-20) !important;
  color: var(--neutral-gray-20);
  background-color: unset;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL {
  border: 1px solid var(--neutral-base-black);
  background-color: var(--neutral-base-white);
  color: var(--neutral-base-black);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL:hover,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL:hover {
  background-color: var(--neutral-gray-10);
  border: 1px solid var(--neutral-base-black);
  color: var(--neutral-base-black);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL:active,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL:active {
  border: 1px solid var(--neutral-base-black) !important;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL:disabled, ._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL[aria-disabled=true],
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL:disabled,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-black___rgoFL[aria-disabled=true] {
  border-color: var(--neutral-gray-20) !important;
  color: var(--neutral-gray-20);
  background-color: unset;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC {
  border: 1px solid var(--neutral-gray-40);
  background-color: var(--neutral-base-white);
  color: var(--neutral-base-black);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC:hover,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC:hover {
  background-color: var(--neutral-gray-10);
  border: 1px solid var(--neutral-gray-40);
  color: var(--neutral-base-black);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC:active,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC:active {
  border: 1px solid var(--neutral-gray-40) !important;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC:disabled, ._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC[aria-disabled=true],
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC:disabled,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-gray___JxYvC[aria-disabled=true] {
  border-color: var(--neutral-gray-20) !important;
  color: var(--neutral-gray-20);
  background-color: unset;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR {
  border: 1px solid var(--neutral-base-white);
  background-color: var(--neutral-base-black);
  color: var(--neutral-base-white);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR:hover,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR:hover {
  background-color: var(--neutral-gray-80);
  border: 1px solid var(--neutral-base-white);
  color: var(--neutral-base-white);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR:active,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR:active {
  border: 1px solid var(--neutral-base-white) !important;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR:disabled, ._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR[aria-disabled=true],
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR:disabled,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-white___1kMMR[aria-disabled=true] {
  border-color: var(--neutral-gray-80) !important;
  color: var(--neutral-gray-80);
  background-color: unset;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN {
  border: 1px solid var(--sentiment-error-50);
  color: var(--sentiment-error-50);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN:hover,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN:hover {
  background-color: var(--sentiment-error-10);
  border: 1px solid var(--sentiment-error-50);
  color: var(--sentiment-error-50);
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN:active,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN:active {
  border: 1px solid var(--sentiment-error-50) !important;
}
._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN:disabled, ._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN[aria-disabled=true],
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN:disabled,
a._baseButton-module__button-secondary___BpcuR._baseButton-module__button-destructive___2OpdN[aria-disabled=true] {
  border-color: var(--neutral-gray-20) !important;
  color: var(--neutral-gray-20);
  background-color: unset;
}

._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil {
  color: var(--brand-purple-50);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil:hover,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil:hover {
  background-color: var(--brand-purple-10);
  color: var(--brand-purple-50);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil:active,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil:active {
  background-color: var(--brand-purple-10);
  color: var(--brand-purple-70);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil:disabled, ._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil[aria-disabled=true],
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil:disabled,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-purple___31oil[aria-disabled=true] {
  color: var(--neutral-gray-20);
  background-color: unset;
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL {
  color: var(--neutral-base-black);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL:hover,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL:hover {
  background-color: var(--neutral-gray-20);
  color: var(--neutral-base-black);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL:active,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL:active {
  background-color: var(--neutral-gray-20);
  color: var(--neutral-gray-80);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL:disabled, ._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL[aria-disabled=true],
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL:disabled,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-black___rgoFL[aria-disabled=true] {
  color: var(--neutral-gray-20);
  background-color: unset;
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR {
  color: var(--neutral-base-white);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR:hover,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR:hover {
  background-color: var(--neutral-white-alpha-30);
  color: var(--neutral-base-white);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR:active,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR:active {
  background-color: var(--neutral-white-alpha-30);
  color: var(--neutral-gray-20);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR:disabled, ._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR[aria-disabled=true],
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR:disabled,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-white___1kMMR[aria-disabled=true] {
  color: var(--neutral-gray-80);
  background-color: unset;
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC {
  color: var(--text-neutral-quaternary);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC:hover,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC:hover {
  background-color: var(--background-neutral-quaternary);
  color: var(--text-neutral-quaternary);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC:active,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC:active {
  background-color: var(--background-neutral-quaternary);
  color: var(--text-neutral-tertiary);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC:disabled, ._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC[aria-disabled=true],
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC:disabled,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-gray___JxYvC[aria-disabled=true] {
  color: var(--text-neutral-disabled);
  background-color: unset;
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN {
  color: var(--sentiment-error-50);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN:hover,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN:hover {
  background-color: var(--sentiment-error-10);
  color: var(--sentiment-error-50);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN:active,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN:active {
  background-color: var(--sentiment-error-10);
  color: var(--sentiment-error-70);
}
._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN:disabled, ._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN[aria-disabled=true],
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN:disabled,
a._baseButton-module__button-tertiary___MMZKG._baseButton-module__button-destructive___2OpdN[aria-disabled=true] {
  color: var(--neutral-gray-20);
  background-color: unset;
}

._baseButton-module__button-l___RV0rB,
a._baseButton-module__button-l___RV0rB {
  padding: 0.625rem 1rem;
  gap: 0.5rem;
}
._baseButton-module__button-l___RV0rB span,
a._baseButton-module__button-l___RV0rB span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.4;
  margin: 1px 0 0;
}
._baseButton-module__button-l___RV0rB i,
a._baseButton-module__button-l___RV0rB i {
  font-size: 1.1875rem;
  line-height: 125%;
  width: 1.5rem;
}
._baseButton-module__button-l___RV0rB._baseButton-module__button-iconOnly___zWjVA,
._baseButton-module__button-l___RV0rB ._baseButton-module__button-iconBorder___viZ36,
a._baseButton-module__button-l___RV0rB._baseButton-module__button-iconOnly___zWjVA,
a._baseButton-module__button-l___RV0rB ._baseButton-module__button-iconBorder___viZ36 {
  padding: 0.75rem;
}

._baseButton-module__button-m___1eKjJ,
a._baseButton-module__button-m___1eKjJ {
  padding: 0.5rem 1rem;
  gap: 0.5rem;
}
._baseButton-module__button-m___1eKjJ span,
a._baseButton-module__button-m___1eKjJ span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.48;
  margin: 1px 0 0;
}
._baseButton-module__button-m___1eKjJ i,
a._baseButton-module__button-m___1eKjJ i {
  font-size: 1rem;
  line-height: 125%;
  width: 1.25rem;
}
._baseButton-module__button-m___1eKjJ._baseButton-module__button-iconOnly___zWjVA, ._baseButton-module__button-m___1eKjJ._baseButton-module__button-iconBorder___viZ36,
a._baseButton-module__button-m___1eKjJ._baseButton-module__button-iconOnly___zWjVA,
a._baseButton-module__button-m___1eKjJ._baseButton-module__button-iconBorder___viZ36 {
  padding: 0.625rem;
}

._baseButton-module__button-s___WsV-p,
a._baseButton-module__button-s___WsV-p {
  padding: 0.3125rem 1rem;
  gap: 0.5rem;
}
._baseButton-module__button-s___WsV-p span,
a._baseButton-module__button-s___WsV-p span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.54;
  margin: 1px 0 0;
}
._baseButton-module__button-s___WsV-p i,
a._baseButton-module__button-s___WsV-p i {
  font-size: 0.875rem;
  line-height: 125%;
  width: 1.125rem;
}
._baseButton-module__button-s___WsV-p._baseButton-module__button-iconOnly___zWjVA, ._baseButton-module__button-s___WsV-p._baseButton-module__button-iconBorder___viZ36,
a._baseButton-module__button-s___WsV-p._baseButton-module__button-iconOnly___zWjVA,
a._baseButton-module__button-s___WsV-p._baseButton-module__button-iconBorder___viZ36 {
  padding: 0.4375rem;
}

._baseButton-module__button-xs___VnYav,
a._baseButton-module__button-xs___VnYav {
  padding: 0.125rem 0.5rem;
  gap: 0.25rem;
}
._baseButton-module__button-xs___VnYav span,
a._baseButton-module__button-xs___VnYav span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.64;
  margin: 1px 0 0;
}
._baseButton-module__button-xs___VnYav i,
a._baseButton-module__button-xs___VnYav i {
  font-size: 0.8125rem;
  line-height: 125%;
  width: 1rem;
}
._baseButton-module__button-xs___VnYav._baseButton-module__button-iconOnly___zWjVA, ._baseButton-module__button-xs___VnYav._baseButton-module__button-iconBorder___viZ36,
a._baseButton-module__button-xs___VnYav._baseButton-module__button-iconOnly___zWjVA,
a._baseButton-module__button-xs___VnYav._baseButton-module__button-iconBorder___viZ36 {
  padding: 0.25rem;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css));
var baseButton_module_default = {
  "button": "_baseButton-module__button___gGYwf",
  "buttonPendingWithHiddenText": "_baseButton-module__buttonPendingWithHiddenText___1W2Ul",
  "button-primary": "_baseButton-module__button-primary___2ksGH",
  "button-purple": "_baseButton-module__button-purple___31oil",
  "button-black": "_baseButton-module__button-black___rgoFL",
  "button-white": "_baseButton-module__button-white___1kMMR",
  "button-destructive": "_baseButton-module__button-destructive___2OpdN",
  "button-secondary": "_baseButton-module__button-secondary___BpcuR",
  "button-gray": "_baseButton-module__button-gray___JxYvC",
  "button-tertiary": "_baseButton-module__button-tertiary___MMZKG",
  "button-l": "_baseButton-module__button-l___RV0rB",
  "button-iconOnly": "_baseButton-module__button-iconOnly___zWjVA",
  "button-iconBorder": "_baseButton-module__button-iconBorder___viZ36",
  "button-m": "_baseButton-module__button-m___1eKjJ",
  "button-s": "_baseButton-module__button-s___WsV-p",
  "button-xs": "_baseButton-module__button-xs___VnYav"
};

// src/button/_BaseButton.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");
var checkButtonPropsForErrors = ({
  icon,
  useAsLink,
  onClick,
  href,
  download,
  text,
  isIconOnly,
  color,
  type
}) => {
  if (color === "gray" && type == "primary" || color === "gray" && type === "tertiary" && !isIconOnly) {
    throw new Error(
      "Expect type prop to be secondary or tertiary(with isIconOnly prop set to true) when color is gray"
    );
  }
  if (color === "purple" && type === "secondary") {
    console.warn(
      "Warning: Button - Secondary Purple color is now deprecated. Please use different color or type. Secondary purple combination will be removed very soon."
    );
  }
  if (useAsLink) {
    if (!href) {
      throw new Error("Expect href prop when useAsLink is true");
    }
    if (onClick) {
      throw new Error(
        "Expect onClick prop to be undefined when useAsLink is true"
      );
    }
  }
  if (!useAsLink) {
    if (!onClick) {
      throw new Error("Expect onClick prop when useAsLink is false");
    }
    if (href) {
      throw new Error(
        "Expect href prop to be undefined when useAsLink is false"
      );
    }
    if (download) {
      throw new Error(
        "Expect download prop to be undefined when useAsLink is false"
      );
    }
  }
  if (isIconOnly) {
    if (!icon) {
      throw new Error("Expect icon prop when isIconOnly is true");
    }
    if (text) {
      throw new Error(
        "Expect text prop to be undefined when isIconOnly is true"
      );
    }
  }
  if (!isIconOnly) {
    if (icon) {
      throw new Error(
        "Expect icon prop to be undefined when isIconOnly is false"
      );
    }
    if (!text) {
      throw new Error("Expect text prop when isIconOnly is false");
    }
  }
};
var spinnerIcon = {
  iconName: "spinner",
  iconStyle: "solid",
  animationType: "spin"
};
var BaseButton = ({
  className,
  id,
  disabled = false,
  isPending = false,
  ariaLabel,
  size = "m",
  type = "primary",
  color = "purple",
  buttonTagTypeAttribute = "button",
  /** Text button specific props */
  iconLeft,
  iconRight,
  text,
  /** IconOnly button specific props*/
  isIconOnly = false,
  icon,
  /** <a> specific props */
  useAsLink = false,
  href,
  target,
  download,
  title,
  /** <button> specific props */
  onClick,
  value,
  name,
  ...rest
}) => {
  const ButtonTag = useAsLink ? "a" : "button";
  const tagSpecificProps = ButtonTag === "a" ? {
    href: disabled ? void 0 : href,
    target,
    /** Copied from old button component. Only need it for the older browsers,
     *  since modern browsers (~2020+ release year secures these vulnerabilities by default) */
    // Opening links in new tabs with 'target=_blank' is inherently insecure. Unfortunately, we depend
    // on this functionality in a couple of place. Fortunately, it is possible to partially mitigate some of
    // the insecurity of this functionality by using the `rel` tag to block some of the potential exploits.
    // Therefore, we do so here.
    rel: target === "_blank" ? "noopener noreferrer" : void 0,
    download,
    title
  } : { type: buttonTagTypeAttribute, onClick, value, name };
  (0, import_react2.useMemo)(
    () => checkButtonPropsForErrors({
      type,
      icon,
      useAsLink,
      onClick,
      href,
      download,
      text,
      isIconOnly,
      color
    }),
    [type, icon, useAsLink, onClick, href, download, text, isIconOnly, color]
  );
  const showIcon = icon && !isPending;
  const showIconLeft = iconLeft && !isPending;
  const showIconRight = iconRight && !isPending || isPending && iconRight && iconLeft;
  const addPendingButtonWithHiddenTextClass = isPending && !icon && !iconLeft && !iconRight;
  const spinnerPosition = iconRight && !iconLeft ? "right" : "left";
  return /* @__PURE__ */ (0, import_jsx_runtime3.jsxs)(
    ButtonTag,
    {
      className: (0, import_classnames2.default)(
        baseButton_module_default.button,
        baseButton_module_default[`button-${type}`],
        baseButton_module_default[`button-${color}`],
        baseButton_module_default[`button-${size}`],
        isIconOnly && baseButton_module_default["button-iconOnly"],
        addPendingButtonWithHiddenTextClass && baseButton_module_default.buttonPendingWithHiddenText,
        className
      ),
      id,
      disabled,
      ...rest,
      "aria-disabled": disabled || rest["aria-disabled"],
      "aria-label": ariaLabel || rest["aria-label"],
      ...tagSpecificProps,
      children: [
        isPending && spinnerPosition === "left" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon }),
        showIconLeft && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconLeft }),
        showIcon && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...icon }),
        text && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)("span", { children: text }),
        showIconRight && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...iconRight }),
        isPending && spinnerPosition === "right" && /* @__PURE__ */ (0, import_jsx_runtime3.jsx)(FontAwesomeV6Icon_default, { ...spinnerIcon })
      ]
    }
  );
};
var BaseButton_default = (0, import_react2.memo)(BaseButton);

// src/button/Button.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");
var buttonColors = {
  purple: "purple",
  black: "black",
  gray: "gray",
  white: "white",
  destructive: "destructive"
};
var Button = (props) => /* @__PURE__ */ (0, import_jsx_runtime4.jsx)(BaseButton_default, { ...props });
var Button_default = (0, import_react3.memo)(Button);

// src/common/constants/index.ts
var componentSizeToBodyTextSizeMap = {
  l: "body-one",
  m: "body-two",
  s: "body-three",
  xs: "body-four"
};
var dropdownColors = {
  white: "white",
  black: "black",
  gray: "gray"
};

// src/common/helpers/index.ts
var getAriaPropsFromProps = (props) => {
  const ariaProps = {};
  Object.keys(props).forEach((key) => {
    if (key.startsWith("aria-")) {
      ariaProps[key] = props[key];
    }
  });
  return ariaProps;
};

// src/dropdown/customDropdown.module.scss
var css2 = `@charset "UTF-8";
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This file is being copied and adopted to shared/css/typography.scss
   Updating styles in this file will require a manual sync of the that file.
*/
@font-face {
  font-family: "Barlow Semi Condensed Semibold";
  font-style: normal;
  font-weight: 600;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-SemiBold.ttf") format("truetype"), local("?");
}
@font-face {
  font-family: "Barlow Semi Condensed Medium";
  font-style: normal;
  font-weight: 500;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-Medium.ttf") format("truetype"), local("?");
}
html {
  font-size: 100%;
}

/* \u2014 example: all h3s in a ul need to look like h5s
    ul.icon-list {
      h3 { @include heading-sm }
    }
*/
.customDropdown-module__heading-xxl___BfDpQ {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 3rem;
  line-height: 1.16;
}

.customDropdown-module__heading-xl___hBTTG {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 2.125rem;
  line-height: 1.24;
}

.customDropdown-module__heading-lg___7BsKx {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.75rem;
  line-height: 1.28;
}

.customDropdown-module__heading-md___xxLoj {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-medium), "Barlow Semi Condensed Medium", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.5rem;
  line-height: 1.32;
}

.customDropdown-module__heading-sm___9iG3J {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.25rem;
  line-height: 1.4;
}

.customDropdown-module__heading-xs___lrvOk {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.48;
}

.customDropdown-module__body-one___X7Z9b {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
}

.customDropdown-module__body-two___yBWgp {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
}

.customDropdown-module__body-three___wsuRX {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
}

.customDropdown-module__body-four___HuISj {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
}

.customDropdown-module__overline-one___RpfOR {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.875rem;
  line-height: 1.6;
}

.customDropdown-module__overline-two___vpAsZ {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.813rem;
  line-height: 1.64;
}

.customDropdown-module__overline-three___mVI8k {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.688rem;
  line-height: 1.76;
}

strong,
.customDropdown-module__strong___e5JvH {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.customDropdown-module__extra-strong___UAzFh {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
}

em,
.customDropdown-module__em___-ermV {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-style: italic;
}

strong em,
em strong,
.customDropdown-module__em___-ermV .customDropdown-module__strong___e5JvH,
.customDropdown-module__strong___e5JvH .customDropdown-module__em___-ermV {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-style: italic;
}

.customDropdown-module__em___-ermV .customDropdown-module__extra-strong___UAzFh,
.customDropdown-module__extra-strong___UAzFh .customDropdown-module__em___-ermV,
em .customDropdown-module__extra-strong___UAzFh,
.customDropdown-module__extra-strong___UAzFh em {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-style: italic;
}

figcaption,
.customDropdown-module__figcaption___GzPqv {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.813rem;
  margin: 0.5em 0 1em;
  line-height: 1.64;
}

.customDropdown-module__dropdownContainer___3BIP8 {
  position: relative;
  display: inline-block;
  margin: 0;
}
.customDropdown-module__dropdownContainer___3BIP8.customDropdown-module__styleAsFormField___xI7en {
  width: 18.75rem;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}
.customDropdown-module__dropdownContainer___3BIP8.customDropdown-module__styleAsFormField___xI7en button {
  width: 100%;
}
.customDropdown-module__dropdownContainer___3BIP8.customDropdown-module__styleAsFormField___xI7en button span {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: start;
  white-space: nowrap;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownLabel___v0iA- {
  display: block;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownButton___smtEn {
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  width: auto;
  background-color: unset;
  border-radius: 0.25rem;
  border: 1px solid;
  color: var(--neutral-base-black);
  box-shadow: none;
  gap: 0.5rem;
  margin: 0;
  cursor: pointer;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownButton___smtEn:focus-visible {
  outline: 2px solid var(--brand-teal-50);
  border-radius: 0.25rem;
  outline-offset: 2px;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownButton___smtEn i {
  display: inline-block;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownButton___smtEn span {
  /* Manually center dropdown button label */
  margin-top: 2px;
}
.customDropdown-module__dropdownContainer___3BIP8.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn {
  opacity: 1;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__helperSection___MS5Cc {
  display: flex;
  align-items: baseline;
  align-self: stretch;
  margin-top: 0.125rem;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb {
  position: absolute;
  bottom: auto;
  z-index: 1000;
  display: none;
  float: left;
  margin: 0.25rem 0;
  list-style: none;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  -webkit-box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  background-clip: padding-box;
  padding: 0.25rem 0 0;
  white-space: nowrap;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul {
  margin: 0;
  padding: 0;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li {
  list-style-type: none;
  display: flex;
  align-items: flex-end;
  align-self: stretch;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- {
  /* Reset's every elements apperance */
  background: none repeat scroll 0 0 transparent;
  border: none !important;
  border-radius: 0;
  border-spacing: 0;
  list-style: none outside none;
  margin: 0;
  padding: 0;
  text-decoration: none;
  text-indent: 0;
  box-shadow: none;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--neutral-base-black);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V-.customDropdown-module__destructiveDropdownMenuItem___EN9g6 {
  color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V-.customDropdown-module__destructiveDropdownMenuItem___EN9g6 i {
  color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V-.customDropdown-module__destructiveDropdownMenuItem___EN9g6:hover {
  background-color: var(--sentiment-error-10);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V-.customDropdown-module__destructiveDropdownMenuItem___EN9g6:active {
  background-color: var(--sentiment-error-50);
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V-.customDropdown-module__destructiveDropdownMenuItem___EN9g6:active i::before {
  background-color: var(--sentiment-error-50);
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V-:focus-visible {
  outline: 2px solid var(--brand-teal-50);
  outline-offset: -2px;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- i {
  display: inline-block;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li label,
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- {
  flex-grow: 1;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:hover {
  background-color: var(--neutral-gray-10);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:active, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:checked), .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__selectedDropdownMenuItem___9szis) {
  background-color: var(--brand-teal-50);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:active i::before, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:checked) i::before, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__selectedDropdownMenuItem___9szis) i::before {
  background-color: var(--neutral-base-white);
  color: var(--brand-teal-50);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:active span, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:checked) span, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__selectedDropdownMenuItem___9szis) span {
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:active .customDropdown-module__dropdownMenuItem___k0-V- i::before, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:checked) .customDropdown-module__dropdownMenuItem___k0-V- i::before, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__selectedDropdownMenuItem___9szis) .customDropdown-module__dropdownMenuItem___k0-V- i::before {
  background-color: var(--brand-teal-50);
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:active .customDropdown-module__dropdownMenuItem___k0-V- span, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:checked) .customDropdown-module__dropdownMenuItem___k0-V- span, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__selectedDropdownMenuItem___9szis) .customDropdown-module__dropdownMenuItem___k0-V- span {
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:disabled), .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__disabledDropdownMenuItem___JXRFz) {
  color: var(--neutral-gray-20);
  background-color: unset;
  cursor: not-allowed;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:disabled) .customDropdown-module__dropdownMenuItem___k0-V-, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__disabledDropdownMenuItem___JXRFz) .customDropdown-module__dropdownMenuItem___k0-V- {
  cursor: not-allowed;
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:disabled) .customDropdown-module__dropdownMenuItem___k0-V- i::before, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__disabledDropdownMenuItem___JXRFz) .customDropdown-module__dropdownMenuItem___k0-V- i::before {
  background-color: unset;
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:disabled) span,
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(input[type=checkbox]:disabled) .customDropdown-module__dropdownMenuItem___k0-V- span, .customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__disabledDropdownMenuItem___JXRFz) span,
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__dropdownMenuContainer___MddCb ul li:has(.customDropdown-module__disabledDropdownMenuItem___JXRFz) .customDropdown-module__dropdownMenuItem___k0-V- span {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer___3BIP8 .customDropdown-module__bottomButtonsContainer___t9sSU {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 0.25rem;
  border-radius: 0 0 0.25rem 0.25rem;
  border-top: 1px solid var(--neutral-gray-30);
}

.customDropdown-module__dropdownContainer___3BIP8.customDropdown-module__open___vYM0Z .customDropdown-module__dropdownMenuContainer___MddCb {
  display: block;
}

.customDropdown-module__dropdownContainer-left-menuPlacement___qGtiT .customDropdown-module__dropdownMenuContainer___MddCb {
  inset-inline-start: 0;
}

.customDropdown-module__dropdownContainer-right-menuPlacement___a6Zft .customDropdown-module__dropdownMenuContainer___MddCb {
  inset-inline-end: 0;
}

.customDropdown-module__dropdownContainer-black___Vur3p .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-base-black);
}
.customDropdown-module__dropdownContainer-black___Vur3p .customDropdown-module__helperSection___MS5Cc {
  color: var(--neutral-base-black);
}
.customDropdown-module__dropdownContainer-black___Vur3p.customDropdown-module__hasError___CxxfS .customDropdown-module__errorSection___8w-fJ {
  color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer-black___Vur3p.customDropdown-module__hasError___CxxfS .customDropdown-module__dropdownButton___smtEn {
  border-color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer-black___Vur3p .customDropdown-module__dropdownButton___smtEn {
  color: var(--neutral-base-black);
  border-color: var(--neutral-base-black);
  background-color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:hover) .customDropdown-module__dropdownButton___smtEn:not(:disabled) {
  color: var(--neutral-base-black);
  background-color: var(--neutral-gray-10);
}
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:active) .customDropdown-module__dropdownButton___smtEn:not(:disabled) {
  color: var(--neutral-base-black);
  background-color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownButton___smtEn {
  color: var(--neutral-gray-20);
  border-color: var(--neutral-gray-20) !important;
  cursor: not-allowed;
}
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownButton___smtEn .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__helperSection___MS5Cc,
.customDropdown-module__dropdownContainer-black___Vur3p:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__errorSection___8w-fJ {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer-black___Vur3p.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn:disabled {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.customDropdown-module__dropdownContainer-black___Vur3p.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn:disabled .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.customDropdown-module__dropdownContainer-black___Vur3p.customDropdown-module__readOnly___QcxON .customDropdown-module__helperSection___MS5Cc,
.customDropdown-module__dropdownContainer-black___Vur3p.customDropdown-module__readOnly___QcxON .customDropdown-module__errorSection___8w-fJ {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}

.customDropdown-module__dropdownContainer-gray___CsmLB .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-base-black);
}
.customDropdown-module__dropdownContainer-gray___CsmLB .customDropdown-module__helperSection___MS5Cc {
  color: var(--neutral-base-black);
}
.customDropdown-module__dropdownContainer-gray___CsmLB.customDropdown-module__hasError___CxxfS .customDropdown-module__errorSection___8w-fJ {
  color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer-gray___CsmLB .customDropdown-module__dropdownButton___smtEn {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-40);
  background-color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:hover) .customDropdown-module__dropdownButton___smtEn:not(:disabled) {
  color: var(--neutral-base-black);
  background-color: var(--neutral-gray-10);
}
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:active) .customDropdown-module__dropdownButton___smtEn:not(:disabled) {
  color: var(--neutral-base-black);
  background-color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownButton___smtEn {
  color: var(--neutral-gray-20);
  border-color: var(--neutral-gray-20) !important;
  cursor: not-allowed;
}
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownButton___smtEn .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__helperSection___MS5Cc,
.customDropdown-module__dropdownContainer-gray___CsmLB:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__errorSection___8w-fJ {
  color: var(--neutral-gray-20);
}
.customDropdown-module__dropdownContainer-gray___CsmLB.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn:disabled {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.customDropdown-module__dropdownContainer-gray___CsmLB.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn:disabled .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.customDropdown-module__dropdownContainer-gray___CsmLB.customDropdown-module__readOnly___QcxON .customDropdown-module__helperSection___MS5Cc,
.customDropdown-module__dropdownContainer-gray___CsmLB.customDropdown-module__readOnly___QcxON .customDropdown-module__errorSection___8w-fJ {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}

.customDropdown-module__dropdownContainer-white___p--cG .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-white___p--cG .customDropdown-module__helperSection___MS5Cc {
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-white___p--cG.customDropdown-module__hasError___CxxfS .customDropdown-module__errorSection___8w-fJ {
  color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer-white___p--cG.customDropdown-module__hasError___CxxfS .customDropdown-module__dropdownButton___smtEn {
  border-color: var(--sentiment-error-50);
}
.customDropdown-module__dropdownContainer-white___p--cG .customDropdown-module__dropdownButton___smtEn {
  color: var(--neutral-base-white);
  border-color: var(--neutral-base-white);
  background-color: var(--neutral-base-black);
}
.customDropdown-module__dropdownContainer-white___p--cG .customDropdown-module__dropdownButton___smtEn span {
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-white___p--cG:has(.customDropdown-module__dropdownButton___smtEn:hover) .customDropdown-module__dropdownButton___smtEn:not(:disabled) {
  color: var(--neutral-base-white);
  background-color: var(--neutral-gray-90);
}
.customDropdown-module__dropdownContainer-white___p--cG:has(.customDropdown-module__dropdownButton___smtEn:active) .customDropdown-module__dropdownButton___smtEn:not(:disabled) {
  color: var(--neutral-base-white);
}
.customDropdown-module__dropdownContainer-white___p--cG:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownButton___smtEn {
  color: var(--neutral-gray-90);
  border-color: var(--neutral-gray-90);
  cursor: not-allowed;
}
.customDropdown-module__dropdownContainer-white___p--cG:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__dropdownButton___smtEn .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-gray-90);
}
.customDropdown-module__dropdownContainer-white___p--cG:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__helperSection___MS5Cc,
.customDropdown-module__dropdownContainer-white___p--cG:has(.customDropdown-module__dropdownButton___smtEn:disabled) .customDropdown-module__errorSection___8w-fJ {
  color: var(--neutral-gray-70);
}
.customDropdown-module__dropdownContainer-white___p--cG.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn:disabled {
  color: var(--neutral-base-white);
  border-color: var(--neutral-gray-70);
  background-color: var(--neutral-gray-90);
}
.customDropdown-module__dropdownContainer-white___p--cG.customDropdown-module__readOnly___QcxON .customDropdown-module__dropdownButton___smtEn:disabled .customDropdown-module__dropdownLabel___v0iA- {
  color: var(--neutral-base-white);
  border-color: var(--neutral-gray-70);
  background-color: var(--neutral-gray-90);
}
.customDropdown-module__dropdownContainer-white___p--cG.customDropdown-module__readOnly___QcxON .customDropdown-module__helperSection___MS5Cc,
.customDropdown-module__dropdownContainer-white___p--cG.customDropdown-module__readOnly___QcxON .customDropdown-module__errorSection___8w-fJ {
  color: var(--neutral-base-white);
  border-color: var(--neutral-gray-70);
  background-color: var(--neutral-gray-90);
}

.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownFieldLabel___x61Ds {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0.125rem;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownLabel-thick___t8f6S {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.4;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownLabel-thin___PRIj4 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownButton___smtEn {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.4;
  height: 3rem;
  padding: 0.625rem 1rem;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownButton___smtEn i {
  font-size: 1.1875rem;
  line-height: 125%;
  width: 1.5rem;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__helperSection___MS5Cc {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0;
  gap: 0.375rem;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownMenuContainer___MddCb ul li label,
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- {
  padding: 0.625rem 1rem 0.625rem 0.75rem;
  gap: 0.75rem;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- i {
  font-size: 1.375rem;
  line-height: 125%;
  width: 1.75rem;
}
.customDropdown-module__dropdownContainer-l___EJinx .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
  color: inherit;
  margin-bottom: 0;
}

.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownFieldLabel___x61Ds {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0.125rem;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownLabel-thick___t8f6S {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownLabel-thin___PRIj4 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownButton___smtEn {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.48;
  height: 2.5rem;
  padding: 0.5rem 1rem;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownButton___smtEn i {
  font-size: 1rem;
  line-height: 125%;
  width: 1.25rem;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__helperSection___MS5Cc {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
  gap: 0.375rem;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownMenuContainer___MddCb ul li label,
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- {
  padding: 0.5rem 1rem 0.5rem 0.75rem;
  gap: 0.75rem;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- i {
  font-size: 1.1875rem;
  line-height: 125%;
  width: 1.5rem;
}
.customDropdown-module__dropdownContainer-m___jkvgP .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
  color: inherit;
  margin-bottom: 0;
}

.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownFieldLabel___x61Ds {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.64;
  margin-bottom: 0.125rem;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownLabel-thick___t8f6S {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownLabel-thin___PRIj4 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownButton___smtEn {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.54;
  height: 2rem;
  padding: 0.3125rem 1rem;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownButton___smtEn i {
  font-size: 0.875rem;
  line-height: 125%;
  width: 1.125rem;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__helperSection___MS5Cc {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  margin-bottom: 0;
  gap: 0.25rem;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownMenuContainer___MddCb ul li label,
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- {
  padding: 0.3125rem 0.875rem 0.3125rem 0.625rem;
  gap: 0.5rem;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- i {
  font-size: 1rem;
  line-height: 125%;
  width: 1.25rem;
}
.customDropdown-module__dropdownContainer-s___L81BM .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
  color: inherit;
  margin-bottom: 0;
}

.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownFieldLabel___x61Ds {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.625rem;
  line-height: 1.8;
  margin-bottom: 0.125rem;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownLabel-thick___t8f6S {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.64;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownLabel-thin___PRIj4 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownButton___smtEn {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.64;
  height: 1.5rem;
  padding: 0.125rem 0.5rem;
  margin-bottom: 0;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownButton___smtEn i {
  font-size: 0.8125rem;
  line-height: 125%;
  width: 1rem;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownMenuContainer___MddCb ul li label,
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- {
  padding: 0.125rem 0.625rem 0.125rem 0.5rem;
  gap: 0.25rem;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- i {
  font-size: 0.8125rem;
  line-height: 125%;
  width: 1rem;
}
.customDropdown-module__dropdownContainer-xs___BPccp .customDropdown-module__dropdownMenuContainer___MddCb ul li .customDropdown-module__dropdownMenuItem___k0-V- span {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  color: inherit;
  margin-bottom: 0;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css2));
var customDropdown_module_default = {
  "heading-xxl": "customDropdown-module__heading-xxl___BfDpQ",
  "heading-xl": "customDropdown-module__heading-xl___hBTTG",
  "heading-lg": "customDropdown-module__heading-lg___7BsKx",
  "heading-md": "customDropdown-module__heading-md___xxLoj",
  "heading-sm": "customDropdown-module__heading-sm___9iG3J",
  "heading-xs": "customDropdown-module__heading-xs___lrvOk",
  "body-one": "customDropdown-module__body-one___X7Z9b",
  "body-two": "customDropdown-module__body-two___yBWgp",
  "body-three": "customDropdown-module__body-three___wsuRX",
  "body-four": "customDropdown-module__body-four___HuISj",
  "overline-one": "customDropdown-module__overline-one___RpfOR",
  "overline-two": "customDropdown-module__overline-two___vpAsZ",
  "overline-three": "customDropdown-module__overline-three___mVI8k",
  "strong": "customDropdown-module__strong___e5JvH",
  "extra-strong": "customDropdown-module__extra-strong___UAzFh",
  "em": "customDropdown-module__em___-ermV",
  "figcaption": "customDropdown-module__figcaption___GzPqv",
  "dropdownContainer": "customDropdown-module__dropdownContainer___3BIP8",
  "styleAsFormField": "customDropdown-module__styleAsFormField___xI7en",
  "dropdownLabel": "customDropdown-module__dropdownLabel___v0iA-",
  "dropdownButton": "customDropdown-module__dropdownButton___smtEn",
  "readOnly": "customDropdown-module__readOnly___QcxON",
  "helperSection": "customDropdown-module__helperSection___MS5Cc",
  "dropdownMenuContainer": "customDropdown-module__dropdownMenuContainer___MddCb",
  "dropdownMenuItem": "customDropdown-module__dropdownMenuItem___k0-V-",
  "destructiveDropdownMenuItem": "customDropdown-module__destructiveDropdownMenuItem___EN9g6",
  "selectedDropdownMenuItem": "customDropdown-module__selectedDropdownMenuItem___9szis",
  "disabledDropdownMenuItem": "customDropdown-module__disabledDropdownMenuItem___JXRFz",
  "bottomButtonsContainer": "customDropdown-module__bottomButtonsContainer___t9sSU",
  "open": "customDropdown-module__open___vYM0Z",
  "dropdownContainer-left-menuPlacement": "customDropdown-module__dropdownContainer-left-menuPlacement___qGtiT",
  "dropdownContainer-right-menuPlacement": "customDropdown-module__dropdownContainer-right-menuPlacement___a6Zft",
  "dropdownContainer-black": "customDropdown-module__dropdownContainer-black___Vur3p",
  "hasError": "customDropdown-module__hasError___CxxfS",
  "errorSection": "customDropdown-module__errorSection___8w-fJ",
  "dropdownContainer-gray": "customDropdown-module__dropdownContainer-gray___CsmLB",
  "dropdownContainer-white": "customDropdown-module__dropdownContainer-white___p--cG",
  "dropdownContainer-l": "customDropdown-module__dropdownContainer-l___EJinx",
  "dropdownFieldLabel": "customDropdown-module__dropdownFieldLabel___x61Ds",
  "dropdownLabel-thick": "customDropdown-module__dropdownLabel-thick___t8f6S",
  "dropdownLabel-thin": "customDropdown-module__dropdownLabel-thin___PRIj4",
  "dropdownContainer-m": "customDropdown-module__dropdownContainer-m___jkvgP",
  "dropdownContainer-s": "customDropdown-module__dropdownContainer-s___L81BM",
  "dropdownContainer-xs": "customDropdown-module__dropdownContainer-xs___BPccp"
};

// src/dropdown/_CustomDropdown.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");
var CustomDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  children,
  isSomeValueSelected = false,
  icon,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  menuPlacement = "left",
  useDSCOButtonAsTrigger = false,
  triggerButtonProps = {},
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  selectedValueText,
  ...rest
}) => {
  const { activeDropdownName, setActiveDropdownName } = useDropdownContext();
  const dropdownRef = (0, import_react4.useRef)(null);
  const handleClickOutside = (0, import_react4.useCallback)(
    (event) => {
      if (activeDropdownName && dropdownRef.current && event.target instanceof Node && !dropdownRef.current.contains(event.target)) {
        setActiveDropdownName("");
      }
    },
    [dropdownRef, setActiveDropdownName, activeDropdownName]
  );
  const ariaProps = getAriaPropsFromProps(rest);
  (0, import_react4.useEffect)(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleClickOutside);
    };
  }, [handleClickOutside]);
  (0, import_react4.useEffect)(() => {
    if (useDSCOButtonAsTrigger && !triggerButtonProps) {
      console.warn(
        "Warning: `triggerButtonProps` must be defined when `useDSCOButtonAsTrigger` is true."
      );
    }
  }, [useDSCOButtonAsTrigger, triggerButtonProps]);
  const toggleDropdown = (0, import_react4.useCallback)(() => {
    if (activeDropdownName !== name) {
      setActiveDropdownName(name);
    } else {
      setActiveDropdownName("");
    }
  }, [name, activeDropdownName, setActiveDropdownName]);
  const isOpen = (0, import_react4.useMemo)(
    () => activeDropdownName === name,
    [activeDropdownName, name]
  );
  const onKeyDown = (e) => {
    if (e.key === "Escape") {
      e.currentTarget.classList.remove(customDropdown_module_default.open);
    }
  };
  const triggerComponentProps = {
    id: `${name}-dropdown-button`,
    "data-toggle": "dropdown",
    onClick: toggleDropdown,
    disabled: disabled || readOnly,
    ...ariaProps,
    "aria-haspopup": true,
    "aria-label": ariaProps["aria-label"] || `${name} filter dropdown`
  };
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
      "div",
      {
        id: `${name}-dropdown`,
        className: (0, import_classnames3.default)(
          {
            [customDropdown_module_default.open]: isOpen,
            [customDropdown_module_default.hasError]: errorMessage,
            [customDropdown_module_default.readOnly]: readOnly,
            [customDropdown_module_default.styleAsFormField]: styleAsFormField
          },
          customDropdown_module_default.dropdownContainer,
          customDropdown_module_default[`dropdownContainer-${menuPlacement}-menuPlacement`],
          customDropdown_module_default[`dropdownContainer-${color}`],
          customDropdown_module_default[`dropdownContainer-${size}`],
          className
        ),
        onKeyDown,
        ref: dropdownRef,
        "aria-describedby": ariaProps["aria-describedby"],
        children: [
          styleAsFormField && labelText && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("div", { children: /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { className: customDropdown_module_default.dropdownFieldLabel, children: labelText }) }),
          useDSCOButtonAsTrigger ? /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
            Button_default,
            {
              ...triggerComponentProps,
              ...triggerButtonProps,
              size,
              "aria-label": (triggerButtonProps == null ? void 0 : triggerButtonProps.isIconOnly) ? labelText : triggerButtonProps["aria-label"] || triggerComponentProps["aria-label"]
            }
          ) : /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "button",
            {
              ...triggerComponentProps,
              type: "button",
              className: customDropdown_module_default.dropdownButton,
              children: [
                isSomeValueSelected && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName: "check-circle", iconStyle: "solid" }),
                icon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                  FontAwesomeV6Icon_default,
                  {
                    iconName: icon.iconName,
                    iconStyle: icon.iconStyle,
                    title: icon.title,
                    className: icon.className
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(
                  "span",
                  {
                    className: (0, import_classnames3.default)(
                      customDropdown_module_default.dropdownLabel,
                      customDropdown_module_default[`dropdownLabel-${styleAsFormField ? "thin" : labelType}`]
                    ),
                    children: styleAsFormField ? selectedValueText : labelText
                  }
                ),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconStyle: "solid", iconName: "chevron-down" })
              ]
            }
          ),
          children,
          !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)("div", { className: customDropdown_module_default.helperSection, children: [
            helperIcon && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
            helperMessage && /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: helperMessage })
          ] }),
          errorMessage && /* @__PURE__ */ (0, import_jsx_runtime5.jsxs)(
            "div",
            {
              className: (0, import_classnames3.default)(
                customDropdown_module_default.errorSection,
                customDropdown_module_default.helperSection
              ),
              children: [
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
                /* @__PURE__ */ (0, import_jsx_runtime5.jsx)("span", { children: errorMessage })
              ]
            }
          )
        ]
      }
    )
  );
};
var CustomDropdown_default = CustomDropdown;

// src/dropdown/actionDropdown/ActionDropdown.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");
var ActionDropdown = ({
  name,
  className,
  labelText,
  options,
  disabled = false,
  menuPlacement = "left",
  size = "m",
  triggerButtonProps,
  ...rest
}) => {
  const { setActiveDropdownName } = useDropdownContext();
  const onOptionClick = (0, import_react5.useCallback)(
    (optionOnClick) => {
      if (!disabled) {
        optionOnClick();
        setActiveDropdownName("");
      }
    },
    [disabled, setActiveDropdownName]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      disabled,
      menuPlacement,
      size,
      ...rest,
      useDSCOButtonAsTrigger: true,
      triggerButtonProps,
      children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("div", { className: customDropdown_module_default.dropdownMenuContainer, children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("ul", { children: options.map((option) => {
        const {
          value,
          label,
          onClick,
          isOptionDisabled,
          isOptionDestructive,
          icon: {
            iconName,
            iconStyle,
            title: iconTitle,
            className: iconClassName
          }
        } = option;
        return /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsxs)(
          "button",
          {
            className: (0, import_classnames4.default)(
              customDropdown_module_default.dropdownMenuItem,
              isOptionDisabled && customDropdown_module_default.disabledDropdownMenuItem,
              isOptionDestructive && customDropdown_module_default.destructiveDropdownMenuItem
            ),
            disabled: isOptionDisabled || disabled,
            type: "button",
            onClick: () => onOptionClick(onClick),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(
                FontAwesomeV6Icon_default,
                {
                  iconName,
                  iconStyle,
                  title: iconTitle,
                  className: iconClassName
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime6.jsx)("span", { children: label })
            ]
          }
        ) }, value);
      }) }) })
    }
  );
};
var WrappedActionDropdown = (props) => /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(DropdownProviderWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime6.jsx)(ActionDropdown, { ...props }) });
var ActionDropdown_default = (0, import_react5.memo)(WrappedActionDropdown);

// src/dropdown/checkboxDropdown/CheckboxDropdown.tsx
var import_react8 = require("react");

// src/checkbox/Checkbox.tsx
var import_classnames6 = __toESM(require("classnames"));
var import_react7 = require("react");

// src/typography/Typography.tsx
var import_classnames5 = __toESM(require("classnames"));
var import_react6 = require("react");

// ../component-library-styles/typography.module.scss
var css3 = `@charset "UTF-8";
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This file is being copied and adopted to shared/css/typography.scss
   Updating styles in this file will require a manual sync of the that file.
*/
@font-face {
  font-family: "Barlow Semi Condensed Semibold";
  font-style: normal;
  font-weight: 600;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-SemiBold.ttf") format("truetype"), local("?");
}
@font-face {
  font-family: "Barlow Semi Condensed Medium";
  font-style: normal;
  font-weight: 500;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-Medium.ttf") format("truetype"), local("?");
}
html {
  font-size: 100%;
}

/* \u2014 example: all h3s in a ul need to look like h5s
    ul.icon-list {
      h3 { @include heading-sm }
    }
*/
.typography-module__heading-xxl___t4Iml {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 3rem;
  line-height: 1.16;
}

.typography-module__heading-xl___wbMqr {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 2.125rem;
  line-height: 1.24;
}

.typography-module__heading-lg___GUMI7 {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.75rem;
  line-height: 1.28;
}

.typography-module__heading-md___I661h {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-medium), "Barlow Semi Condensed Medium", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.5rem;
  line-height: 1.32;
}

.typography-module__heading-sm___2Jm-k {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.25rem;
  line-height: 1.4;
}

.typography-module__heading-xs___FJljd {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.48;
}

.typography-module__body-one___hKZXX {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
}

.typography-module__body-two___Sa-Eb {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
}

.typography-module__body-three___FIk3k {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
}

.typography-module__body-four___vI1SQ {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
}

.typography-module__overline-one___rXzIm {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.875rem;
  line-height: 1.6;
}

.typography-module__overline-two___WG6bF {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.813rem;
  line-height: 1.64;
}

.typography-module__overline-three___UK5T- {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.688rem;
  line-height: 1.76;
}

strong,
.typography-module__strong___jtYq4 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.typography-module__extra-strong___9SBuV {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
}

em,
.typography-module__em___2kNMg {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-style: italic;
}

strong em,
em strong,
.typography-module__em___2kNMg .typography-module__strong___jtYq4,
.typography-module__strong___jtYq4 .typography-module__em___2kNMg {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-style: italic;
}

.typography-module__em___2kNMg .typography-module__extra-strong___9SBuV,
.typography-module__extra-strong___9SBuV .typography-module__em___2kNMg,
em .typography-module__extra-strong___9SBuV,
.typography-module__extra-strong___9SBuV em {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-style: italic;
}

figcaption,
.typography-module__figcaption___cHscw {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.813rem;
  margin: 0.5em 0 1em;
  line-height: 1.64;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css3));
var typography_module_default = {
  "heading-xxl": "typography-module__heading-xxl___t4Iml",
  "heading-xl": "typography-module__heading-xl___wbMqr",
  "heading-lg": "typography-module__heading-lg___GUMI7",
  "heading-md": "typography-module__heading-md___I661h",
  "heading-sm": "typography-module__heading-sm___2Jm-k",
  "heading-xs": "typography-module__heading-xs___FJljd",
  "body-one": "typography-module__body-one___hKZXX",
  "body-two": "typography-module__body-two___Sa-Eb",
  "body-three": "typography-module__body-three___FIk3k",
  "body-four": "typography-module__body-four___vI1SQ",
  "overline-one": "typography-module__overline-one___rXzIm",
  "overline-two": "typography-module__overline-two___WG6bF",
  "overline-three": "typography-module__overline-three___UK5T-",
  "strong": "typography-module__strong___jtYq4",
  "extra-strong": "typography-module__extra-strong___9SBuV",
  "em": "typography-module__em___2kNMg",
  "figcaption": "typography-module__figcaption___cHscw"
};

// src/typography/Typography.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");
var Typography = ({
  semanticTag,
  visualAppearance,
  children,
  className,
  style,
  id,
  ...props
}) => {
  const Tag = semanticTag;
  return /* @__PURE__ */ (0, import_jsx_runtime7.jsx)(
    Tag,
    {
      id,
      className: (0, import_classnames5.default)(typography_module_default[visualAppearance], className),
      style,
      ...props,
      children
    }
  );
};
var Typography_default = (0, import_react6.memo)(Typography);

// src/checkbox/checkbox.module.scss
var css4 = `/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

.checkbox-module__label___ooRXo {
  display: flex;
  gap: 8px;
  align-items: center;
}
.checkbox-module__label___ooRXo i {
  vertical-align: bottom;
}
.checkbox-module__label___ooRXo i::before {
  display: inline-block;
  content: " ";
  text-align: center;
  border: 2px solid var(--neutral-base-black);
  border-radius: 4px;
}
.checkbox-module__label___ooRXo span {
  margin-bottom: 0;
}
.checkbox-module__label___ooRXo input[type=checkbox] {
  position: absolute;
  opacity: 0;
}
.checkbox-module__label___ooRXo input[type=checkbox]:checked + i::before {
  content: "\\f00c";
  color: var(--neutral-base-white);
  background: var(--brand-teal-50);
  border: 2px solid var(--brand-teal-50);
  border-radius: 4px;
}
.checkbox-module__label___ooRXo input[type=checkbox]:indeterminate + i::before {
  content: "\\e404";
  color: var(--neutral-base-white);
  background: var(--brand-teal-50);
  border: 2px solid var(--brand-teal-50);
  border-radius: 4px;
}
.checkbox-module__label___ooRXo input[type=checkbox]:focus-visible + i::before {
  outline: 2px solid var(--brand-teal-50);
  outline-offset: 2px;
  border-radius: 4px;
}
.checkbox-module__label___ooRXo input[type=checkbox]:focus-visible:indeterminate + i::before {
  color: var(--neutral-base-white);
  background: var(--brand-teal-50);
  border: 2px solid var(--brand-teal-50);
}
.checkbox-module__label___ooRXo:hover {
  cursor: pointer;
}
.checkbox-module__label___ooRXo:hover i::before {
  background-color: var(--brand-teal-5);
}
.checkbox-module__label___ooRXo:hover input[type=checkbox]:checked + i::before, .checkbox-module__label___ooRXo:hover input[type=checkbox]:indeterminate + i::before {
  color: var(--neutral-base-white);
  background: var(--brand-teal-70);
  border-color: var(--brand-teal-70);
}
.checkbox-module__label___ooRXo:active i::before {
  background-color: var(--brand-teal-5);
  border-color: var(--brand-teal-50);
}
.checkbox-module__label___ooRXo:active input[type=checkbox]:checked + i::before, .checkbox-module__label___ooRXo:active input[type=checkbox]:indeterminate + i::before {
  color: var(--neutral-base-white);
  background: var(--brand-teal-70);
  border-color: var(--brand-teal-50);
}
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled) span {
  color: var(--neutral-gray-20);
}
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled) i::before {
  border-color: var(--neutral-gray-20);
}
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled) input[type=checkbox]:checked + i::before, .checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled) input[type=checkbox]:indeterminate + i::before {
  background: var(--neutral-gray-20);
  color: var(--neutral-base-white);
}
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled):hover {
  cursor: not-allowed;
}
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled):hover i::before {
  background: var(--neutral-base-white);
}
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled):hover input[type=checkbox]:checked + i::before,
.checkbox-module__label___ooRXo:has(input[type=checkbox]:disabled):hover input[type=checkbox]:indeterminate + i::before {
  background: var(--neutral-gray-20);
  border-color: var(--neutral-gray-20);
}

.checkbox-module__label-xs___e32xy i {
  width: 16px;
  height: 16px;
}
.checkbox-module__label-xs___e32xy i::before {
  font-size: 8px;
  width: 12px;
  height: 12px;
  line-height: 12px;
}

.checkbox-module__label-s___hafkQ i {
  width: 18px;
  height: 18px;
}
.checkbox-module__label-s___hafkQ i::before {
  font-size: 9.5px;
  width: 14px;
  height: 14px;
  line-height: 14px;
}

.checkbox-module__label-m___CBOxg i {
  width: 20px;
  height: 20px;
}
.checkbox-module__label-m___CBOxg i::before {
  font-size: 11px;
  width: 16px;
  height: 16px;
  line-height: 16px;
}

.checkbox-module__label-l___7U6JB i {
  width: 24px;
  height: 24px;
}
.checkbox-module__label-l___7U6JB i::before {
  font-size: 13px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css4));
var checkbox_module_default = {
  "label": "checkbox-module__label___ooRXo",
  "label-xs": "checkbox-module__label-xs___e32xy",
  "label-s": "checkbox-module__label-s___hafkQ",
  "label-m": "checkbox-module__label-m___CBOxg",
  "label-l": "checkbox-module__label-l___7U6JB"
};

// src/checkbox/Checkbox.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");
var Checkbox = ({
  label,
  checked,
  onChange,
  name,
  value,
  disabled = false,
  indeterminate = false,
  size = "m",
  ...HTMLAttributes3
}) => {
  const checkboxRef = (0, import_react7.useRef)(null);
  const bodyTextSize = componentSizeToBodyTextSizeMap[size];
  (0, import_react7.useEffect)(() => {
    if (checkboxRef == null ? void 0 : checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate;
    }
  }, [checkboxRef, indeterminate]);
  return /* @__PURE__ */ (0, import_jsx_runtime8.jsxs)(
    "label",
    {
      className: (0, import_classnames6.default)(checkbox_module_default.label, checkbox_module_default[`label-${size}`]),
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(
          "input",
          {
            type: "checkbox",
            ref: checkboxRef,
            name,
            value,
            checked,
            disabled,
            onChange,
            ...HTMLAttributes3
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime8.jsx)("i", { className: "fa-solid" }),
        label && /* @__PURE__ */ (0, import_jsx_runtime8.jsx)(Typography_default, { semanticTag: "span", visualAppearance: bodyTextSize, children: label })
      ]
    }
  );
};
var Checkbox_default = Checkbox;

// src/dropdown/checkboxDropdown/CheckboxDropdown.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var CheckboxDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  allOptions,
  checkedOptions = [],
  onChange,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  ...rest
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      labelType,
      color,
      disabled,
      readOnly,
      size,
      isSomeValueSelected: checkedOptions.length > 0,
      helperMessage,
      helperIcon,
      errorMessage,
      styleAsFormField,
      selectedValueText: checkedOptions == null ? void 0 : checkedOptions.map((str) => {
        var _a;
        return (_a = allOptions.find((opt) => opt.value === str)) == null ? void 0 : _a.label;
      }).join(", "),
      ...rest,
      children: /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: customDropdown_module_default.dropdownMenuContainer, children: [
        /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("ul", { children: allOptions.map(({ value, label, isOptionDisabled }) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
          Checkbox_default,
          {
            checked: checkedOptions.includes(value),
            disabled: disabled || isOptionDisabled,
            onChange,
            size,
            name: value,
            value,
            label
          }
        ) }, value)) }),
        !rest.hideControls && /* @__PURE__ */ (0, import_jsx_runtime9.jsxs)("div", { className: customDropdown_module_default.bottomButtonsContainer, children: [
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            Button_default,
            {
              type: "tertiary",
              color: buttonColors.purple,
              text: rest.selectAllText,
              onClick: rest.onSelectAll,
              size
            }
          ),
          /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
            Button_default,
            {
              type: "tertiary",
              color: buttonColors.purple,
              text: rest.clearAllText,
              onClick: rest.onClearAll,
              size
            }
          )
        ] })
      ] })
    }
  );
};
var WrappedCheckboxDropdown = (props) => /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(DropdownProviderWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(CheckboxDropdown, { ...props }) });
var CheckboxDropdown_default = (0, import_react8.memo)(WrappedCheckboxDropdown);

// src/dropdown/iconDropdown/IconDropdown.tsx
var import_classnames7 = __toESM(require("classnames"));
var import_react9 = require("react");
var import_jsx_runtime10 = require("react/jsx-runtime");
var IconDropdown = ({
  name,
  className,
  labelText,
  labelType = "thick",
  options,
  selectedOption = {},
  onChange,
  disabled = false,
  readOnly = false,
  color = dropdownColors.black,
  size = "m",
  helperMessage,
  helperIcon,
  errorMessage,
  styleAsFormField = false,
  ...rest
}) => {
  const { setActiveDropdownName } = useDropdownContext();
  const onOptionClick = (0, import_react9.useCallback)(
    (option) => {
      if (!disabled && !option.isOptionDisabled) {
        onChange(option);
        setActiveDropdownName("");
      }
    },
    [disabled, onChange, setActiveDropdownName]
  );
  return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
    CustomDropdown_default,
    {
      name,
      className,
      labelText,
      labelType,
      disabled,
      readOnly,
      color,
      icon: selectedOption == null ? void 0 : selectedOption.icon,
      size,
      helperMessage,
      helperIcon,
      errorMessage,
      styleAsFormField,
      selectedValueText: selectedOption == null ? void 0 : selectedOption.label,
      ...rest,
      children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("div", { className: customDropdown_module_default.dropdownMenuContainer, children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("ul", { children: options.map((option) => {
        const {
          value,
          label,
          isOptionDisabled,
          icon: {
            iconName,
            iconStyle,
            title: iconTitle,
            className: iconClassName
          }
        } = option;
        return /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("li", { children: /* @__PURE__ */ (0, import_jsx_runtime10.jsxs)(
          "button",
          {
            className: (0, import_classnames7.default)(
              customDropdown_module_default.dropdownMenuItem,
              isOptionDisabled && customDropdown_module_default.disabledDropdownMenuItem,
              selectedOption.value === value && customDropdown_module_default.selectedDropdownMenuItem
            ),
            disabled: isOptionDisabled || disabled,
            type: "button",
            onClick: () => onOptionClick(option),
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(
                FontAwesomeV6Icon_default,
                {
                  iconName,
                  iconStyle,
                  title: iconTitle,
                  className: iconClassName
                }
              ),
              /* @__PURE__ */ (0, import_jsx_runtime10.jsx)("span", { children: label })
            ]
          }
        ) }, value);
      }) }) })
    }
  );
};
var WrappedIconDropdown = (props) => /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(DropdownProviderWrapper, { children: /* @__PURE__ */ (0, import_jsx_runtime10.jsx)(IconDropdown, { ...props }) });
var IconDropdown_default = (0, import_react9.memo)(WrappedIconDropdown);

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_classnames8 = __toESM(require("classnames"));

// src/dropdown/simpleDropdown/simpleDropdown.module.scss
var css5 = `@charset "UTF-8";
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This is a collection of Primitive Colors.
 Unlike Semantic colors (color.css) these variables will be equal to the same color value in all themes.
 Ideally, these colors should be used for components that are not theme dependent.
 In the future it's possible that we will only need to use these colors in Semantic colors (colors.css).
 */
/* Colors are taken from DISCO Variables New Figma File - Primitive colors variables collection
 via variables2css plugin that generates css code based on Figma variables values and names.
 We're using css here in order to support not only scss, but also css files.
 :root is used here instead of "[data-theme="Mode 1"]" to define css variables
 that can be used in the entire app. 
 Also, stylelint fix might be required for autogenerated colors, which can be done in one command.
 */
/* Primitive Colors */
:root {
  --accent-orange-10: #fff6e5;
  --accent-orange-100: #5c3b00;
  --accent-orange-20: #ffe5b7;
  --accent-orange-30: #ffd58a;
  --accent-orange-40: #ffc55c;
  --accent-orange-50: #ffb42e;
  --accent-orange-60: #ffa400;
  --accent-orange-70: #d68a00;
  --accent-orange-80: #ad7000;
  --accent-orange-90: #855500;
  --accent-strawberry-10: #ffe3e3;
  --accent-strawberry-100: #430d0d;
  --accent-strawberry-20: #ffcdcd;
  --accent-strawberry-30: #ffabab;
  --accent-strawberry-40: #f88585;
  --accent-strawberry-50: #ed6060;
  --accent-strawberry-60: #cb4a4a;
  --accent-strawberry-70: #a93737;
  --accent-strawberry-80: #872626;
  --accent-strawberry-90: #651818;
  --brand-aqua-10: #ebfffe;
  --brand-aqua-100: #005552;
  --brand-aqua-20: #bffffc;
  --brand-aqua-30: #94fffb;
  --brand-aqua-40: #68fff9;
  --brand-aqua-50: #3cfff7;
  --brand-aqua-60: #29ddd6;
  --brand-aqua-70: #19bbb5;
  --brand-aqua-80: #0d9994;
  --brand-aqua-90: #047773;
  --brand-purple-10: #e2d4ee;
  --brand-purple-100: #2f1c3e;
  --brand-purple-20: #decaee;
  --brand-purple-30: #d0b6e5;
  --brand-purple-40: #b592d2;
  --brand-purple-5: #f6edfd;
  --brand-purple-50: #8c52ba;
  --brand-purple-60: #7f4aa9;
  --brand-purple-70: #6c468a;
  --brand-purple-80: #5c3778;
  --brand-purple-90: #46295c;
  --brand-teal-10: #bfe4e8;
  --brand-teal-100: #00383f;
  --brand-teal-20: #aed8dc;
  --brand-teal-30: #85cad1;
  --brand-teal-40: #50b2bd;
  --brand-teal-5: #e0f8f9;
  --brand-teal-50: #0093a4;
  --brand-teal-60: #008493;
  --brand-teal-70: #007785;
  --brand-teal-80: #00636e;
  --brand-teal-90: #004b54;
  --neutral-base-black: #292f36;
  --neutral-base-white: #ffffff;
  --neutral-black-alpha-10: #292f361a;
  --neutral-black-alpha-20: #292f3633;
  --neutral-black-alpha-30: #292f364d;
  --neutral-black-alpha-40: #292f3666;
  --neutral-black-alpha-5: #292f360d;
  --neutral-black-alpha-50: #292f3680;
  --neutral-black-alpha-60: #292f3699;
  --neutral-black-alpha-70: #292f36b2;
  --neutral-black-alpha-80: #292f36cc;
  --neutral-black-alpha-90: #292f36e5;
  --neutral-black-alpha-95: #292f36f2;
  --neutral-gray-10: #e4e6e9;
  --neutral-gray-20: #d1d4d8;
  --neutral-gray-30: #bec2c7;
  --neutral-gray-40: #abb0b6;
  --neutral-gray-5: #f7f8fa;
  --neutral-gray-50: #989ea5;
  --neutral-gray-60: #858c94;
  --neutral-gray-70: #727a83;
  --neutral-gray-80: #5f6872;
  --neutral-gray-90: #4c5661;
  --neutral-gray-95: #394450;
  --neutral-white-alpha-10: #ffffff1a;
  --neutral-white-alpha-20: #ffffff33;
  --neutral-white-alpha-30: #ffffff4d;
  --neutral-white-alpha-40: #ffffff66;
  --neutral-white-alpha-5: #ffffff0d;
  --neutral-white-alpha-50: #ffffff80;
  --neutral-white-alpha-60: #ffffff99;
  --neutral-white-alpha-70: #ffffffb2;
  --neutral-white-alpha-80: #ffffffcc;
  --neutral-white-alpha-90: #ffffffe5;
  --neutral-white-alpha-95: #fffffff2;
  --sentiment-error-10: #ffe1dd;
  --sentiment-error-100: #480e07;
  --sentiment-error-20: #ffbfb6;
  --sentiment-error-30: #ff8677;
  --sentiment-error-40: #f95d4a;
  --sentiment-error-50: #e02d16;
  --sentiment-error-60: #c12814;
  --sentiment-error-70: #aa2513;
  --sentiment-error-80: #842418;
  --sentiment-error-90: #6a1b11;
  --sentiment-information-10: #dceffb;
  --sentiment-information-100: #0b2946;
  --sentiment-information-20: #bde0fa;
  --sentiment-information-30: #83c7f6;
  --sentiment-information-40: #40aaf0;
  --sentiment-information-50: #1892e3;
  --sentiment-information-60: #0b71be;
  --sentiment-information-70: #0a5a9a;
  --sentiment-information-80: #0d4d7f;
  --sentiment-information-90: #10416a;
  --sentiment-success-10: #e2f6e2;
  --sentiment-success-100: #0e360f;
  --sentiment-success-20: #c7ecc6;
  --sentiment-success-30: #9adc99;
  --sentiment-success-40: #66c365;
  --sentiment-success-50: #3ea33e;
  --sentiment-success-60: #308930;
  --sentiment-success-70: #286d29;
  --sentiment-success-80: #245724;
  --sentiment-success-90: #1f4820;
  --sentiment-warning-10: #fefce8;
  --sentiment-warning-100: #5e330f;
  --sentiment-warning-20: #fef8c3;
  --sentiment-warning-30: #fded8b;
  --sentiment-warning-40: #fcdc48;
  --sentiment-warning-50: #f9cb28;
  --sentiment-warning-60: #e9ae09;
  --sentiment-warning-70: #c88504;
  --sentiment-warning-80: #a05f08;
  --sentiment-warning-90: #7d4b07;
}

/*
   Font Awesome S3 Bucket URLs
   Current version: 6.6.0
   If you are changing the location of these files,
   see the readme in this directory for more detail on manual steps to take when uploading new files.
 */
/* This file is being copied and adopted to shared/css/typography.scss
   Updating styles in this file will require a manual sync of the that file.
*/
@font-face {
  font-family: "Barlow Semi Condensed Semibold";
  font-style: normal;
  font-weight: 600;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-SemiBold.ttf") format("truetype"), local("?");
}
@font-face {
  font-family: "Barlow Semi Condensed Medium";
  font-style: normal;
  font-weight: 500;
  src: url("/fonts/barlowSemiCondensed/BarlowSemiCondensed-Medium.ttf") format("truetype"), local("?");
}
html {
  font-size: 100%;
}

/* \u2014 example: all h3s in a ul need to look like h5s
    ul.icon-list {
      h3 { @include heading-sm }
    }
*/
.simpleDropdown-module__heading-xxl___9Bn9p {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 3rem;
  line-height: 1.16;
}

.simpleDropdown-module__heading-xl___Bs827 {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 2.125rem;
  line-height: 1.24;
}

.simpleDropdown-module__heading-lg___QaJ50 {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-semi-bold), "Barlow Semi Condensed Semibold", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.75rem;
  line-height: 1.28;
}

.simpleDropdown-module__heading-md___YiLUI {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: var(--font-barlow-semi-condensed-medium), "Barlow Semi Condensed Medium", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-size: 1.5rem;
  line-height: 1.32;
}

.simpleDropdown-module__heading-sm___1n7ps {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1.25rem;
  line-height: 1.4;
}

.simpleDropdown-module__heading-xs___xW-Fr {
  color: var(--neutral-base-black);
  margin: 0 0 0.5em 0;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 1rem;
  line-height: 1.48;
}

.simpleDropdown-module__body-one___7rX-Y {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
}

.simpleDropdown-module__body-two___gILBB {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
}

.simpleDropdown-module__body-three___GOcL8 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
}

.simpleDropdown-module__body-four___xRcct {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
}

.simpleDropdown-module__overline-one___-wIiz {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.875rem;
  line-height: 1.6;
}

.simpleDropdown-module__overline-two___k-quH {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.813rem;
  line-height: 1.64;
}

.simpleDropdown-module__overline-three___GCsDi {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  text-transform: uppercase;
  letter-spacing: 0.04rem;
  font-size: 0.688rem;
  line-height: 1.76;
}

strong,
.simpleDropdown-module__strong___yTyKW {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
}

.simpleDropdown-module__extra-strong___5SWar {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
}

em,
.simpleDropdown-module__em___WbRQ1 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-style: italic;
}

strong em,
em strong,
.simpleDropdown-module__em___WbRQ1 .simpleDropdown-module__strong___yTyKW,
.simpleDropdown-module__strong___yTyKW .simpleDropdown-module__em___WbRQ1 {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-style: italic;
}

.simpleDropdown-module__em___WbRQ1 .simpleDropdown-module__extra-strong___5SWar,
.simpleDropdown-module__extra-strong___5SWar .simpleDropdown-module__em___WbRQ1,
em .simpleDropdown-module__extra-strong___5SWar,
.simpleDropdown-module__extra-strong___5SWar em {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-style: italic;
}

figcaption,
.simpleDropdown-module__figcaption___9LXRt {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 0.813rem;
  margin: 0.5em 0 1em;
  line-height: 1.64;
}

.simpleDropdown-module__dropdownContainer___Cofpg {
  position: relative;
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.125rem;
  margin: 0;
}
.simpleDropdown-module__dropdownContainer___Cofpg.simpleDropdown-module__styleAsFormField___Q-XA0 {
  width: 18.75rem;
  text-wrap: nowrap;
  text-overflow: ellipsis;
}
.simpleDropdown-module__dropdownContainer___Cofpg.simpleDropdown-module__styleAsFormField___Q-XA0 .simpleDropdown-module__dropdownArrowDiv___sw7I5 {
  width: 100%;
}
.simpleDropdown-module__dropdownContainer___Cofpg.simpleDropdown-module__styleAsFormField___Q-XA0 .simpleDropdown-module__dropdownArrowDiv___sw7I5 select {
  flex-grow: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.simpleDropdown-module__dropdownContainer___Cofpg .simpleDropdown-module__dropdownLabel___6guyx {
  display: block;
}
.simpleDropdown-module__dropdownContainer___Cofpg .simpleDropdown-module__iconLeft___J-jKr {
  position: absolute;
  z-index: 1;
}
.simpleDropdown-module__dropdownContainer___Cofpg select {
  display: inline-flex;
  align-items: center;
  align-self: stretch;
  width: 100%;
  background-color: unset;
  border-radius: 0.25rem;
  border: 1px solid;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
.simpleDropdown-module__dropdownContainer___Cofpg select:hover {
  cursor: pointer;
}
.simpleDropdown-module__dropdownContainer___Cofpg select:disabled {
  cursor: not-allowed;
}
.simpleDropdown-module__dropdownContainer___Cofpg select:focus-visible {
  outline: 2px solid var(--brand-teal-50);
  border-radius: 0.25rem;
  outline-offset: 2px;
}
.simpleDropdown-module__dropdownContainer___Cofpg select.simpleDropdown-module__readOnly___X-D0o {
  opacity: 1;
}
.simpleDropdown-module__dropdownContainer___Cofpg .simpleDropdown-module__dropdownArrowDiv___sw7I5 {
  position: relative;
}
.simpleDropdown-module__dropdownContainer___Cofpg .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  content: "\\f078";
  font-family: "Font Awesome 6 Pro", sans-serif;
  position: absolute;
  pointer-events: none;
  text-align: center;
}
.simpleDropdown-module__dropdownContainer___Cofpg .simpleDropdown-module__helperSection___F4FfB {
  display: flex;
  align-items: baseline;
  align-self: stretch;
}

.simpleDropdown-module__dropdownContainer-black___IQkAD .simpleDropdown-module__dropdownLabel___6guyx {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD select {
  color: var(--neutral-base-black);
  border-color: var(--neutral-base-black);
  background-color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD select.simpleDropdown-module__hasError___xXvFC {
  border-color: var(--sentiment-error-50);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD .simpleDropdown-module__helperSection___F4FfB {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD .simpleDropdown-module__errorSection___NXOJi {
  color: var(--sentiment-error-50);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:hover) select:not(:disabled) {
  color: var(--neutral-base-black);
  background-color: var(--neutral-gray-10);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:hover) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:active) select:not(:disabled) {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:active) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:disabled) select {
  color: var(--neutral-gray-20);
  border-color: var(--neutral-gray-20);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:disabled) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-gray-20);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:disabled) .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select:disabled) .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-gray-20);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select.simpleDropdown-module__readOnly___X-D0o) select {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-black___IQkAD:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}

.simpleDropdown-module__dropdownContainer-gray___8GY8V .simpleDropdown-module__dropdownLabel___6guyx {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V select {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-40);
  background-color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V select.simpleDropdown-module__hasError___xXvFC {
  border-color: var(--sentiment-error-50);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V .simpleDropdown-module__helperSection___F4FfB {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V .simpleDropdown-module__errorSection___NXOJi {
  color: var(--sentiment-error-50);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:hover) select:not(:disabled) {
  color: var(--neutral-base-black);
  background-color: var(--neutral-gray-10);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:hover) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:active) select:not(:disabled) {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:active) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:disabled) select {
  color: var(--neutral-gray-20);
  border-color: var(--neutral-gray-20);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:disabled) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-gray-20);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:disabled) .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select:disabled) .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-gray-20);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select.simpleDropdown-module__readOnly___X-D0o) select {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-gray___8GY8V:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-base-black);
  border-color: var(--neutral-gray-20);
  background-color: var(--neutral-gray-5);
}

.simpleDropdown-module__dropdownContainer-white___DjkQ9 .simpleDropdown-module__dropdownLabel___6guyx {
  color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9.simpleDropdown-module__dropdownContainer___Cofpg.simpleDropdown-module__dropdownContainer-thin___F0Lr7 select,
.simpleDropdown-module__dropdownContainer-white___DjkQ9 select {
  color: var(--neutral-base-white);
  border-color: var(--neutral-base-white);
  background-color: var(--neutral-base-black);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9 .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-white___DjkQ9 .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:hover) select:not(:disabled) {
  color: var(--neutral-base-white);
  background-color: var(--neutral-gray-90);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:hover) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:active) select:not(:disabled) {
  color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:active) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:disabled) select {
  color: var(--neutral-gray-90);
  border-color: var(--neutral-gray-90);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:disabled) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-gray-90);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:disabled) .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select:disabled) .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-gray-70);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9 .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-white);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select.simpleDropdown-module__readOnly___X-D0o) select {
  color: var(--neutral-base-white);
  border-color: var(--neutral-gray-70);
  background-color: var(--neutral-gray-90);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  color: var(--neutral-base-white);
  border-color: var(--neutral-gray-70);
  background-color: var(--neutral-gray-90);
}
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__helperSection___F4FfB,
.simpleDropdown-module__dropdownContainer-white___DjkQ9:has(select.simpleDropdown-module__readOnly___X-D0o) .simpleDropdown-module__errorSection___NXOJi {
  color: var(--neutral-base-white);
  border-color: var(--neutral-gray-70);
  background-color: var(--neutral-gray-90);
}

.simpleDropdown-module__dropdownContainer-l___jHZyS.simpleDropdown-module__dropdownContainer-thick___ZiURJ select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1.25rem;
  line-height: 1.4;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS.simpleDropdown-module__dropdownContainer-thin___F0Lr7 select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1.25rem;
  line-height: 1.4;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS .simpleDropdown-module__dropdownLabel___6guyx {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS select {
  height: 3rem;
  padding: 0.625rem 1rem;
  padding-inline-end: 3rem;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS .simpleDropdown-module__iconLeft___J-jKr {
  font-size: 1.1875rem;
  line-height: 125%;
  width: 1.5rem;
  inset-inline-start: 1rem;
  top: 0.825rem;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS:has(.simpleDropdown-module__iconLeft___J-jKr) select {
  padding-inline-start: 3rem;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  font-size: 1.1875rem;
  line-height: 1.25;
  height: 1.5rem;
  width: 1.5rem;
  inset-inline-end: 1rem;
  top: 0.825rem;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS .simpleDropdown-module__helperSection___F4FfB {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0;
  gap: 0.375rem;
}
.simpleDropdown-module__dropdownContainer-l___jHZyS .simpleDropdown-module__helperSection___F4FfB.simpleDropdown-module__errorSection___NXOJi {
  color: var(--sentiment-error-50);
}

.simpleDropdown-module__dropdownContainer-m___49v5k.simpleDropdown-module__dropdownContainer-thick___ZiURJ select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 1rem;
  line-height: 1.48;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-m___49v5k.simpleDropdown-module__dropdownContainer-thin___F0Lr7 select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 1rem;
  line-height: 1.48;
  color: inherit;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-m___49v5k .simpleDropdown-module__dropdownLabel___6guyx {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-m___49v5k select {
  height: 2.5rem;
  padding: 0.5rem 1rem;
  padding-inline-end: 2.75rem;
}
.simpleDropdown-module__dropdownContainer-m___49v5k .simpleDropdown-module__iconLeft___J-jKr {
  font-size: 1rem;
  line-height: 125%;
  width: 1.25rem;
  inset-inline-start: 1rem;
  top: 0.625rem;
}
.simpleDropdown-module__dropdownContainer-m___49v5k:has(.simpleDropdown-module__iconLeft___J-jKr) select {
  padding-inline-start: 2.75rem;
}
.simpleDropdown-module__dropdownContainer-m___49v5k .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  font-size: 1rem;
  line-height: 1.25;
  height: 1.25rem;
  width: 1.25rem;
  inset-inline-end: 1rem;
  top: 0.625rem;
}
.simpleDropdown-module__dropdownContainer-m___49v5k .simpleDropdown-module__helperSection___F4FfB {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
  gap: 0.375rem;
}
.simpleDropdown-module__dropdownContainer-m___49v5k .simpleDropdown-module__helperSection___F4FfB.simpleDropdown-module__errorSection___NXOJi {
  color: var(--sentiment-error-50);
}

.simpleDropdown-module__dropdownContainer-s___fYXZQ.simpleDropdown-module__dropdownContainer-thick___ZiURJ select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ.simpleDropdown-module__dropdownContainer-thin___F0Lr7 select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.875rem;
  line-height: 1.54;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ .simpleDropdown-module__dropdownLabel___6guyx {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.64;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ select {
  height: 2rem;
  padding: 0.3125rem 1rem;
  padding-inline-end: 2.625rem;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ .simpleDropdown-module__iconLeft___J-jKr {
  font-size: 0.875rem;
  line-height: 125%;
  width: 1.125rem;
  inset-inline-start: 1rem;
  top: 0.425rem;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ:has(.simpleDropdown-module__iconLeft___J-jKr) select {
  padding-inline-start: 2.625rem;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  font-size: 0.875rem;
  line-height: 1.25;
  height: 1.125rem;
  width: 1.125rem;
  inset-inline-end: 1rem;
  top: 0.425rem;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ .simpleDropdown-module__helperSection___F4FfB {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  margin-bottom: 0;
  gap: 0.25rem;
}
.simpleDropdown-module__dropdownContainer-s___fYXZQ .simpleDropdown-module__helperSection___F4FfB.simpleDropdown-module__errorSection___NXOJi {
  color: var(--sentiment-error-50);
}

.simpleDropdown-module__dropdownContainer-xs___CaYRZ.simpleDropdown-module__dropdownContainer-thick___ZiURJ select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.75rem;
  line-height: 1.64;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ.simpleDropdown-module__dropdownContainer-thin___F0Lr7 select {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ .simpleDropdown-module__dropdownLabel___6guyx {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 600;
  font-style: normal;
  margin-bottom: 0.5rem;
  font-size: 0.625rem;
  line-height: 1.8;
  margin-bottom: 0;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ select {
  height: 1.5rem;
  padding: 0.125rem 0.5rem;
  padding-inline-end: 1.75rem;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ .simpleDropdown-module__iconLeft___J-jKr {
  font-size: 0.8125rem;
  line-height: 125%;
  width: 1rem;
  inset-inline-start: 0.5rem;
  top: 0.25rem;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ:has(.simpleDropdown-module__iconLeft___J-jKr) select {
  padding-inline-start: 1.75rem;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ .simpleDropdown-module__dropdownArrowDiv___sw7I5:after {
  font-size: 0.8125rem;
  line-height: 1.25;
  height: 1rem;
  width: 1rem;
  inset-inline-end: 0.5rem;
  top: 0.25rem;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ .simpleDropdown-module__helperSection___F4FfB {
  font-family: "Figtree", "Metropolis", "Noto Sans", "Noto Sans Math", "Noto Sans Arabic", "Noto Sans Armenian", "Noto Sans Bengali", "Noto Sans SC", "Noto Sans TC", "Noto Sans Devanagari", "Noto Sans Georgian", "Noto Sans Hebrew", "Noto Sans JP", "Noto Sans Kannada", "Noto Sans Khmer", "Noto Sans KR", "Noto Sans Myanmar", "Noto Sans Sinhala", "Noto Sans Tamil", "Noto Sans Telugu", "Noto Sans Thai", "Noto Sans Thaana", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: var(--neutral-base-black);
  margin-bottom: 1em;
  font-size: 0.813rem;
  line-height: 1.64;
  margin-bottom: 0;
  gap: 0.25rem;
}
.simpleDropdown-module__dropdownContainer-xs___CaYRZ .simpleDropdown-module__helperSection___F4FfB.simpleDropdown-module__errorSection___NXOJi {
  color: var(--sentiment-error-50);
}`;
document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(css5));
var simpleDropdown_module_default = {
  "heading-xxl": "simpleDropdown-module__heading-xxl___9Bn9p",
  "heading-xl": "simpleDropdown-module__heading-xl___Bs827",
  "heading-lg": "simpleDropdown-module__heading-lg___QaJ50",
  "heading-md": "simpleDropdown-module__heading-md___YiLUI",
  "heading-sm": "simpleDropdown-module__heading-sm___1n7ps",
  "heading-xs": "simpleDropdown-module__heading-xs___xW-Fr",
  "body-one": "simpleDropdown-module__body-one___7rX-Y",
  "body-two": "simpleDropdown-module__body-two___gILBB",
  "body-three": "simpleDropdown-module__body-three___GOcL8",
  "body-four": "simpleDropdown-module__body-four___xRcct",
  "overline-one": "simpleDropdown-module__overline-one___-wIiz",
  "overline-two": "simpleDropdown-module__overline-two___k-quH",
  "overline-three": "simpleDropdown-module__overline-three___GCsDi",
  "strong": "simpleDropdown-module__strong___yTyKW",
  "extra-strong": "simpleDropdown-module__extra-strong___5SWar",
  "em": "simpleDropdown-module__em___WbRQ1",
  "figcaption": "simpleDropdown-module__figcaption___9LXRt",
  "dropdownContainer": "simpleDropdown-module__dropdownContainer___Cofpg",
  "styleAsFormField": "simpleDropdown-module__styleAsFormField___Q-XA0",
  "dropdownArrowDiv": "simpleDropdown-module__dropdownArrowDiv___sw7I5",
  "dropdownLabel": "simpleDropdown-module__dropdownLabel___6guyx",
  "iconLeft": "simpleDropdown-module__iconLeft___J-jKr",
  "readOnly": "simpleDropdown-module__readOnly___X-D0o",
  "helperSection": "simpleDropdown-module__helperSection___F4FfB",
  "dropdownContainer-black": "simpleDropdown-module__dropdownContainer-black___IQkAD",
  "hasError": "simpleDropdown-module__hasError___xXvFC",
  "errorSection": "simpleDropdown-module__errorSection___NXOJi",
  "dropdownContainer-gray": "simpleDropdown-module__dropdownContainer-gray___8GY8V",
  "dropdownContainer-white": "simpleDropdown-module__dropdownContainer-white___DjkQ9",
  "dropdownContainer-thin": "simpleDropdown-module__dropdownContainer-thin___F0Lr7",
  "dropdownContainer-l": "simpleDropdown-module__dropdownContainer-l___jHZyS",
  "dropdownContainer-thick": "simpleDropdown-module__dropdownContainer-thick___ZiURJ",
  "dropdownContainer-m": "simpleDropdown-module__dropdownContainer-m___49v5k",
  "dropdownContainer-s": "simpleDropdown-module__dropdownContainer-s___fYXZQ",
  "dropdownContainer-xs": "simpleDropdown-module__dropdownContainer-xs___CaYRZ"
};

// src/dropdown/simpleDropdown/SimpleDropdown.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");
var SimpleDropdown = ({
  items = [],
  itemGroups = [],
  selectedValue,
  onChange,
  name,
  id,
  className,
  labelText,
  iconLeft,
  helperMessage,
  helperIcon,
  errorMessage,
  dropdownTextThickness = "thick",
  isLabelVisible = true,
  disabled = false,
  readOnly = false,
  color = "black",
  size = "m",
  styleAsFormField = false,
  ...rest
}) => /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
  "label",
  {
    className: (0, import_classnames8.default)(
      simpleDropdown_module_default.dropdownContainer,
      simpleDropdown_module_default[`dropdownContainer-${size}`],
      simpleDropdown_module_default[`dropdownContainer-${color}`],
      simpleDropdown_module_default[`dropdownContainer-${dropdownTextThickness}`],
      styleAsFormField && simpleDropdown_module_default.styleAsFormField,
      className
    ),
    "aria-describedby": rest["aria-describedby"],
    children: [
      isLabelVisible && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { className: simpleDropdown_module_default.dropdownLabel, children: labelText }),
      /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: simpleDropdown_module_default.dropdownArrowDiv, children: [
        iconLeft && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          FontAwesomeV6Icon_default,
          {
            ...iconLeft,
            className: (0, import_classnames8.default)(simpleDropdown_module_default.iconLeft, iconLeft.className)
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(
          "select",
          {
            name,
            "aria-label": isLabelVisible ? void 0 : labelText,
            onChange,
            value: selectedValue,
            id,
            disabled: disabled || readOnly,
            className: (0, import_classnames8.default)({
              [simpleDropdown_module_default.hasError]: errorMessage,
              [simpleDropdown_module_default.readOnly]: readOnly
            }),
            ...rest,
            children: itemGroups.length > 0 ? itemGroups.map(({ label, groupItems }, index) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("optgroup", { label, children: groupItems.map(({ value, text }) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("option", { value, children: text }, value)) }, index)) : items.map(({ value, text }) => /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("option", { value, children: text }, value))
          }
        )
      ] }),
      !errorMessage && (helperMessage || helperIcon) && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)("div", { className: simpleDropdown_module_default.helperSection, children: [
        helperIcon && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FontAwesomeV6Icon_default, { ...helperIcon }),
        helperMessage && /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: helperMessage })
      ] }),
      errorMessage && /* @__PURE__ */ (0, import_jsx_runtime11.jsxs)(
        "div",
        {
          className: (0, import_classnames8.default)(
            simpleDropdown_module_default.errorSection,
            simpleDropdown_module_default.helperSection
          ),
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)(FontAwesomeV6Icon_default, { iconName: "circle-exclamation" }),
            /* @__PURE__ */ (0, import_jsx_runtime11.jsx)("span", { children: errorMessage })
          ]
        }
      )
    ]
  }
);
var SimpleDropdown_default = SimpleDropdown;
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ActionDropdown,
  CheckboxDropdown,
  IconDropdown,
  SimpleDropdown,
  dropdownColors
});
